{
  "level": "mt13",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt13",
    "objects": "AREAS.E3:mt13.e3",
    "mesh": "TREES.E3:mt13.e3"
  },
  "spawn_point": {
    "position": [
      -422.80715292758885,
      -1945.1459352448658,
      723.01806640625
    ],
    "facing_rad": 0.0,
    "look_point": [
      -422.80715292758885,
      -1845.1459352448658,
      723.01806640625
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -974.8027954101562,
      -3796.41357421875,
      699.01806640625
    ],
    "bbox_max": [
      435.65338134765625,
      -1775.8438720703125,
      1757.6214599609375
    ],
    "vertex_count": 983,
    "vertices": [
      [
        -955.4569702148438,
        -2167.037841796875,
        942.2496337890625
      ],
      [
        -974.8027954101562,
        -2139.422607421875,
        722.3209228515625
      ],
      [
        -754.6883544921875,
        -2359.7060546875,
        1442.865478515625
      ],
      [
        -741.3680419921875,
        -2370.765380859375,
        1443.3846435546875
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -502.13018798828125,
        -2816.75732421875,
        1479.1107177734375
      ],
      [
        -495.6846008300781,
        -2819.0322265625,
        1478.0430908203125
      ],
      [
        -729.6846313476562,
        -2337.886474609375,
        930.5117797851562
      ],
      [
        -770.8285522460938,
        -2309.6298828125,
        1413.108642578125
      ],
      [
        -752.145263671875,
        -2361.8173828125,
        1442.964599609375
      ],
      [
        -757.4642944335938,
        -2322.2109375,
        1342.03466796875
      ],
      [
        -734.536865234375,
        -2347.26708984375,
        1427.1378173828125
      ],
      [
        -729.0033569335938,
        -2352.36328125,
        1390.960205078125
      ],
      [
        -729.0033569335938,
        -2352.36328125,
        1390.960205078125
      ],
      [
        -724.2152099609375,
        -2356.54345703125,
        1345.988037109375
      ],
      [
        -749.2044067382812,
        -2332.04296875,
        1420.7086181640625
      ],
      [
        -757.4642944335938,
        -2322.2109375,
        1342.03466796875
      ],
      [
        -748.221923828125,
        -2333.05322265625,
        1420.5723876953125
      ],
      [
        -746.9424438476562,
        -2334.37548828125,
        1420.805419921875
      ],
      [
        -827.1676025390625,
        -2208.30859375,
        1063.431396484375
      ],
      [
        -834.5751342773438,
        -2190.7646484375,
        787.6181030273438
      ],
      [
        -729.6846313476562,
        -2337.886474609375,
        930.5117797851562
      ],
      [
        -741.8724365234375,
        -2326.515869140625,
        1126.5184326171875
      ],
      [
        -774.5051879882812,
        -2299.141845703125,
        1403.4530029296875
      ],
      [
        -742.3386840820312,
        -2328.641845703125,
        1229.13818359375
      ],
      [
        -741.8724365234375,
        -2326.515869140625,
        1126.5184326171875
      ],
      [
        -737.9234008789062,
        -2338.6396484375,
        1376.480224609375
      ],
      [
        -742.3386840820312,
        -2328.641845703125,
        1229.1380615234375
      ],
      [
        -737.9234008789062,
        -2338.6396484375,
        1376.480224609375
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4501953125
      ],
      [
        -765.1950073242188,
        -2286.75732421875,
        833.0492553710938
      ],
      [
        -774.9254150390625,
        -2297.943115234375,
        1402.349365234375
      ],
      [
        -781.3870239257812,
        -2279.51025390625,
        1385.3797607421875
      ],
      [
        -778.74169921875,
        -2280.03857421875,
        1270.7828369140625
      ],
      [
        -819.005859375,
        -2224.935791015625,
        1266.926025390625
      ],
      [
        -827.1676025390625,
        -2208.30859375,
        1063.431396484375
      ],
      [
        -778.74169921875,
        -2280.03857421875,
        1270.7828369140625
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4501953125
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7565307617188
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8834228515625
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8834228515625
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.040283203125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.0404052734375
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.8394775390625
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.839599609375
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3525390625
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.908203125
      ],
      [
        -495.3401794433594,
        -2807.683837890625,
        1372.5606689453125
      ],
      [
        -492.5638427734375,
        -2820.1337890625,
        1477.5262451171875
      ],
      [
        -495.4368591308594,
        -2808.2001953125,
        1388.3187255859375
      ],
      [
        -495.48614501953125,
        -2807.910400390625,
        1385.04638671875
      ],
      [
        -495.3401794433594,
        -2807.683837890625,
        1372.5606689453125
      ],
      [
        -495.48614501953125,
        -2807.910400390625,
        1385.04638671875
      ],
      [
        -495.4368591308594,
        -2808.2001953125,
        1388.3187255859375
      ],
      [
        303.9524230957031,
        -3792.079345703125,
        1752.8780517578125
      ],
      [
        315.1397705078125,
        -3781.34228515625,
        1622.210693359375
      ],
      [
        325.8473815917969,
        -3775.821533203125,
        1518.7515869140625
      ],
      [
        315.1397705078125,
        -3781.34228515625,
        1622.210693359375
      ],
      [
        -306.4415588378906,
        -2983.1630859375,
        1431.283447265625
      ],
      [
        330.92059326171875,
        -3796.41357421875,
        1757.6214599609375
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        328.0791320800781,
        -3776.214599609375,
        1518.7890625
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        -230.98654174804688,
        -3014.8681640625,
        707.4091186523438
      ],
      [
        -306.5951843261719,
        -2982.99560546875,
        1431.225341796875
      ],
      [
        -230.98654174804688,
        -3014.8681640625,
        707.4091186523438
      ],
      [
        -230.64047241210938,
        -3014.861328125,
        699.01806640625
      ],
      [
        -325.2165222167969,
        -2956.982421875,
        1402.2528076171875
      ],
      [
        -322.7486572265625,
        -2965.37353515625,
        1425.1151123046875
      ],
      [
        -325.2165222167969,
        -2956.982421875,
        1402.2528076171875
      ],
      [
        -321.032958984375,
        -2940.999267578125,
        1249.1214599609375
      ],
      [
        -313.4547119140625,
        -2966.85888671875,
        1395.33251953125
      ],
      [
        -322.1067199707031,
        -2943.16455078125,
        1321.677978515625
      ],
      [
        -307.68572998046875,
        -2981.805908203125,
        1430.8128662109375
      ],
      [
        -313.4547119140625,
        -2966.85888671875,
        1395.33251953125
      ],
      [
        -322.5382995605469,
        -2941.982666015625,
        1318.00390625
      ],
      [
        -321.032958984375,
        -2940.999267578125,
        1249.12158203125
      ],
      [
        -322.5382995605469,
        -2941.982666015625,
        1318.00390625
      ],
      [
        6.261878967285156,
        -2217.946533203125,
        965.2910766601562
      ],
      [
        435.65338134765625,
        -3795.162109375,
        1520.5963134765625
      ],
      [
        -442.0,
        -1928.0,
        893.5
      ],
      [
        -442.0,
        -1894.5,
        893.5
      ],
      [
        -348.0,
        -1894.5,
        893.5
      ],
      [
        -348.0,
        -1928.0,
        893.5
      ],
      [
        -427.11065673828125,
        -1884.5,
        893.5
      ],
      [
        -427.9731750488281,
        -1884.5,
        893.5
      ],
      [
        -430.0,
        -1884.5,
        893.5
      ],
      [
        -427.9731750488281,
        -1884.5,
        893.5
      ],
      [
        -360.0,
        -1884.5,
        893.5
      ],
      [
        -364.9961242675781,
        -1884.5,
        893.5
      ],
      [
        -405.01934814453125,
        -1884.5,
        893.5
      ],
      [
        -427.11065673828125,
        -1884.5,
        893.5
      ],
      [
        -360.0,
        -1884.5,
        893.5
      ],
      [
        -348.0,
        -1894.5,
        893.5
      ],
      [
        -442.0,
        -1894.5,
        893.5
      ],
      [
        -430.0,
        -1884.5,
        893.5
      ],
      [
        -397.2125244140625,
        -1919.0,
        893.5
      ],
      [
        -396.5,
        -1919.0,
        893.5
      ],
      [
        -395.0,
        -1910.0,
        895.0
      ],
      [
        -391.2826232910156,
        -1910.0,
        895.0
      ],
      [
        -383.7173767089844,
        -1910.0,
        895.0
      ],
      [
        -365.0,
        -1910.0,
        895.0
      ],
      [
        -395.0,
        -1910.0,
        895.0
      ],
      [
        -440.5,
        -1910.0,
        895.0
      ],
      [
        -365.0,
        -1928.0,
        895.0
      ],
      [
        -395.0,
        -1928.0,
        895.0
      ],
      [
        -442.0,
        -1928.0,
        895.0
      ],
      [
        -442.0,
        -1910.0,
        893.5
      ],
      [
        -442.0,
        -1910.0,
        895.0
      ],
      [
        -348.0,
        -1910.0,
        893.5
      ],
      [
        -348.0,
        -1928.0,
        895.0
      ],
      [
        -348.0,
        -1910.0,
        895.0
      ],
      [
        -395.0,
        -1919.0,
        895.0
      ],
      [
        -395.0,
        -1928.0,
        895.0
      ],
      [
        -397.9250183105469,
        -1919.0,
        895.0
      ],
      [
        -396.5,
        -1919.0,
        895.0
      ],
      [
        -395.0,
        -1919.0,
        895.0
      ],
      [
        -396.5,
        -1919.0,
        895.0
      ],
      [
        -391.2826232910156,
        -1910.0,
        895.0
      ],
      [
        -391.2826232910156,
        -1911.0,
        895.0
      ],
      [
        -386.5,
        -1886.0,
        895.0
      ],
      [
        -385.75,
        -1886.0,
        895.0
      ],
      [
        -385.75,
        -1886.0,
        895.0
      ],
      [
        -385.0,
        -1886.0,
        895.0
      ],
      [
        -381.5,
        -1886.0,
        895.0
      ],
      [
        -385.0,
        -1886.0,
        895.0
      ],
      [
        -381.5,
        -1886.0,
        895.0
      ],
      [
        -365.0,
        -1886.0,
        895.0
      ],
      [
        -427.53570556640625,
        -1886.0,
        895.0
      ],
      [
        -426.31817626953125,
        -1886.0,
        895.0
      ],
      [
        -430.0,
        -1886.0,
        895.0
      ],
      [
        -427.53570556640625,
        -1886.0,
        895.0
      ],
      [
        -426.31817626953125,
        -1886.0,
        895.0
      ],
      [
        -386.5,
        -1886.0,
        895.0
      ],
      [
        -424.21685791015625,
        -1884.5,
        895.0
      ],
      [
        -425.9432067871094,
        -1884.5,
        895.0
      ],
      [
        -430.0,
        -1884.5,
        895.0
      ],
      [
        -425.9432067871094,
        -1884.5,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        895.0
      ],
      [
        -424.21685791015625,
        -1884.5,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        895.0
      ],
      [
        -358.20001220703125,
        -1886.0,
        893.5
      ],
      [
        -358.20001220703125,
        -1886.0,
        895.0
      ],
      [
        -431.79998779296875,
        -1886.0,
        893.5
      ],
      [
        -430.0,
        -1884.5,
        895.0
      ],
      [
        -431.79998779296875,
        -1886.0,
        895.0
      ],
      [
        -349.79998779296875,
        -1893.0,
        893.5
      ],
      [
        -349.79998779296875,
        -1893.0,
        894.5
      ],
      [
        -358.20001220703125,
        -1886.0,
        894.5
      ],
      [
        -440.20001220703125,
        -1893.0,
        893.5
      ],
      [
        -431.79998779296875,
        -1886.0,
        894.5
      ],
      [
        -440.20001220703125,
        -1893.0,
        894.5
      ],
      [
        -365.0,
        -1893.0,
        893.5
      ],
      [
        -365.0,
        -1886.0,
        894.5
      ],
      [
        -365.0,
        -1893.0,
        894.5
      ],
      [
        -420.5,
        -1893.0,
        894.5
      ],
      [
        -420.5,
        -1886.0,
        894.5
      ],
      [
        -420.5,
        -1893.0,
        893.5
      ],
      [
        -386.5,
        -1886.0,
        894.0
      ],
      [
        -386.5,
        -1890.0,
        893.5
      ],
      [
        -386.5,
        -1890.0,
        894.0
      ],
      [
        -386.5,
        -1890.0,
        894.5
      ],
      [
        -442.0,
        -1894.5,
        894.5
      ],
      [
        -442.0,
        -1910.0,
        894.5
      ],
      [
        -348.0,
        -1894.5,
        894.5
      ],
      [
        -348.0,
        -1910.0,
        894.5
      ],
      [
        -365.0,
        -1895.0,
        894.5
      ],
      [
        -365.0,
        -1895.0,
        894.5
      ],
      [
        -365.0,
        -1910.0,
        894.5
      ],
      [
        -348.0,
        -1894.5,
        894.5
      ],
      [
        -440.5,
        -1910.0,
        894.5
      ],
      [
        -440.5,
        -1895.0,
        894.5
      ],
      [
        -442.0,
        -1894.5,
        894.5
      ],
      [
        -440.5,
        -1893.25,
        893.5
      ],
      [
        -440.5,
        -1893.25,
        894.5
      ],
      [
        -420.5,
        -1893.5,
        894.5
      ],
      [
        -421.0,
        -1894.5,
        894.5
      ],
      [
        -420.5,
        -1893.5,
        894.5
      ],
      [
        -416.5,
        -1887.0,
        895.0
      ],
      [
        -390.5,
        -1887.0,
        895.0
      ],
      [
        -380.0,
        -1887.0,
        894.5
      ],
      [
        -380.0,
        -1887.0,
        895.0
      ],
      [
        -357.0,
        -1887.0,
        895.0
      ],
      [
        -357.0,
        -1887.0,
        894.5
      ],
      [
        -365.0,
        -1887.0,
        894.5
      ],
      [
        -365.0,
        -1886.0,
        895.0
      ],
      [
        -365.0,
        -1887.0,
        895.0
      ],
      [
        -370.0,
        -1887.0,
        895.0
      ],
      [
        -370.0,
        -1887.0,
        894.5
      ],
      [
        -433.0,
        -1887.0,
        894.5
      ],
      [
        -433.0,
        -1887.0,
        895.0
      ],
      [
        -390.5,
        -1887.0,
        895.0
      ],
      [
        -390.5,
        -1886.0,
        895.0
      ],
      [
        -420.5,
        -1887.0,
        895.0
      ],
      [
        -420.5,
        -1886.0,
        895.0
      ],
      [
        -420.5,
        -1887.0,
        894.5
      ],
      [
        -442.0,
        -1894.5,
        895.0
      ],
      [
        -348.0,
        -1894.5,
        895.0
      ],
      [
        -365.0,
        -1895.0,
        895.0
      ],
      [
        -365.0,
        -1895.0,
        895.0
      ],
      [
        -365.0,
        -1910.0,
        895.0
      ],
      [
        -348.0,
        -1894.5,
        895.0
      ],
      [
        -440.5,
        -1910.0,
        895.0
      ],
      [
        -440.5,
        -1895.0,
        895.0
      ],
      [
        -442.0,
        -1894.5,
        895.0
      ],
      [
        -440.5,
        -1893.25,
        894.5
      ],
      [
        -440.5,
        -1893.25,
        895.0
      ],
      [
        -420.5,
        -1888.0,
        895.0
      ],
      [
        -420.5,
        -1888.0,
        894.5
      ],
      [
        -420.5,
        -1893.5,
        895.0
      ],
      [
        -420.5,
        -1893.5,
        895.0
      ],
      [
        -421.0,
        -1894.5,
        895.0
      ],
      [
        -481.2185974121094,
        -1922.61865234375,
        975.0
      ],
      [
        -471.9983825683594,
        -1918.0701904296875,
        902.1705932617188
      ],
      [
        -471.0864562988281,
        -1917.456787109375,
        895.0
      ],
      [
        -471.9983825683594,
        -1918.0701904296875,
        902.1705932617188
      ],
      [
        -361.5999755859375,
        -1776.2037353515625,
        933.0
      ],
      [
        -361.5999755859375,
        -1777.00439453125,
        927.0407104492188
      ],
      [
        -361.5999755859375,
        -1777.00439453125,
        927.0407104492188
      ],
      [
        -361.5999755859375,
        -1776.2037353515625,
        933.0
      ],
      [
        -348.0,
        -1900.24951171875,
        912.0
      ],
      [
        -348.0,
        -1900.24951171875,
        912.0
      ],
      [
        -357.67523193359375,
        -1928.0,
        926.5128784179688
      ],
      [
        -430.0,
        -1904.117919921875,
        930.0
      ],
      [
        -360.0,
        -1899.6497802734375,
        930.0
      ],
      [
        -430.0,
        -1902.99072265625,
        921.0
      ],
      [
        -365.0,
        -1898.8416748046875,
        921.0
      ],
      [
        -354.0,
        -1917.4586181640625,
        921.0
      ],
      [
        -360.0,
        -1899.6497802734375,
        930.0
      ],
      [
        -354.0,
        -1898.1395263671875,
        921.0
      ],
      [
        -436.0,
        -1903.3736572265625,
        921.0
      ],
      [
        -430.0,
        -1904.117919921875,
        930.0
      ],
      [
        -436.0,
        -1928.0,
        921.0
      ],
      [
        -442.0,
        -1910.0,
        912.0
      ],
      [
        -442.0,
        -1910.0,
        895.0
      ],
      [
        -351.3995361328125,
        -1910.0,
        917.0993041992188
      ],
      [
        -354.0,
        -1910.0,
        921.0
      ],
      [
        -442.0,
        -1910.0,
        912.0
      ],
      [
        -436.0,
        -1910.0,
        921.0
      ],
      [
        -432.734375,
        -1910.0,
        918.5
      ],
      [
        -430.0,
        -1906.5,
        921.0
      ],
      [
        -432.734375,
        -1906.5,
        918.5
      ],
      [
        -436.0,
        -1906.5,
        921.0
      ],
      [
        -437.6666564941406,
        -1910.0,
        918.5
      ],
      [
        -437.6666564941406,
        -1906.5,
        918.5
      ],
      [
        -352.3333435058594,
        -1910.0,
        918.5
      ],
      [
        -354.0,
        -1906.5,
        921.0
      ],
      [
        -352.3333435058594,
        -1906.5,
        918.5
      ],
      [
        -381.1428527832031,
        -1908.142822265625,
        918.5
      ],
      [
        -368.8571472167969,
        -1908.142822265625,
        918.5
      ],
      [
        -381.1428527832031,
        -1908.142822265625,
        918.5
      ],
      [
        -381.1428527832031,
        -1910.0,
        918.5
      ],
      [
        -365.0,
        -1908.0,
        921.0
      ],
      [
        -365.0,
        -1910.0,
        918.5
      ],
      [
        -365.0,
        -1908.142822265625,
        918.5
      ],
      [
        -396.0,
        -1908.1142578125,
        919.0
      ],
      [
        -396.0,
        -1908.142822265625,
        918.5
      ],
      [
        -365.0,
        -1906.5,
        921.0
      ],
      [
        -365.0,
        -1906.5,
        918.5
      ],
      [
        -352.3333435058594,
        -1897.719970703125,
        918.5
      ],
      [
        -365.0,
        -1898.8416748046875,
        921.0
      ],
      [
        -365.0,
        -1898.528564453125,
        918.5
      ],
      [
        -430.0,
        -1902.99072265625,
        921.0
      ],
      [
        -432.734375,
        -1902.85205078125,
        918.5
      ],
      [
        -437.6666564941406,
        -1903.1668701171875,
        918.5
      ],
      [
        -442.0,
        -1904.0140380859375,
        912.0
      ],
      [
        -442.0,
        -1900.4998779296875,
        895.0
      ],
      [
        -365.0,
        -1897.6392822265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1896.962890625,
        906.0
      ],
      [
        -365.0,
        -1897.6392822265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1896.962890625,
        906.0
      ],
      [
        -365.0,
        -1895.5850830078125,
        895.0
      ],
      [
        -348.0,
        -1896.6292724609375,
        912.0
      ],
      [
        -348.0,
        -1896.6292724609375,
        912.0
      ],
      [
        -440.5,
        -1902.4583740234375,
        911.4000244140625
      ],
      [
        -442.0,
        -1904.0140380859375,
        912.0
      ],
      [
        -441.5740966796875,
        -1902.68212890625,
        912.6388549804688
      ],
      [
        -440.5,
        -1902.4583740234375,
        911.4000244140625
      ],
      [
        -440.5,
        -1901.781982421875,
        906.0
      ],
      [
        -440.5,
        -1901.781982421875,
        906.0
      ],
      [
        -440.5,
        -1900.4041748046875,
        895.0
      ],
      [
        -442.0,
        -1902.6292724609375,
        912.0
      ],
      [
        -442.0,
        -1902.6292724609375,
        912.0
      ],
      [
        -436.0,
        -1894.5,
        921.0
      ],
      [
        -436.0,
        -1903.37353515625,
        921.0
      ],
      [
        -354.0,
        -1894.5,
        921.0
      ],
      [
        -360.0,
        -1889.5,
        921.0
      ],
      [
        -430.0,
        -1889.5,
        921.0
      ],
      [
        -436.0,
        -1894.5,
        921.0
      ],
      [
        -354.0,
        -1898.1395263671875,
        921.0
      ],
      [
        -354.0,
        -1894.5,
        921.0
      ],
      [
        -357.5251159667969,
        -1886.5623779296875,
        912.0
      ],
      [
        -353.64447021484375,
        -1894.5,
        920.4666748046875
      ],
      [
        -432.4748840332031,
        -1886.5623779296875,
        912.0
      ],
      [
        -436.35552978515625,
        -1894.5,
        920.4666748046875
      ],
      [
        -360.0,
        -1884.5,
        909.8001098632812
      ],
      [
        -357.5251159667969,
        -1886.5623779296875,
        912.0
      ],
      [
        -430.0,
        -1884.5,
        909.8001098632812
      ],
      [
        -432.4748840332031,
        -1886.5623779296875,
        912.0
      ],
      [
        -354.0,
        -1895.0,
        921.0
      ],
      [
        -353.64447021484375,
        -1894.5,
        920.4666748046875
      ],
      [
        -436.35552978515625,
        -1894.5,
        920.4666748046875
      ],
      [
        -436.0,
        -1895.0,
        921.0
      ],
      [
        -419.5,
        -1885.0,
        906.0
      ],
      [
        -387.5,
        -1885.0,
        906.0
      ],
      [
        -387.5,
        -1885.0,
        906.0
      ],
      [
        -419.5,
        -1885.0,
        906.0
      ],
      [
        -360.0,
        -1884.5,
        906.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        906.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        910.3334350585938
      ],
      [
        -430.0,
        -1884.5,
        906.0
      ],
      [
        -430.6000061035156,
        -1885.0,
        910.3334350585938
      ],
      [
        -430.6000061035156,
        -1885.0,
        906.0
      ],
      [
        -358.1999816894531,
        -1886.0,
        906.0
      ],
      [
        -358.1999816894531,
        -1886.0,
        911.400146484375
      ],
      [
        -431.8000183105469,
        -1886.0,
        911.400146484375
      ],
      [
        -431.8000183105469,
        -1886.0,
        906.0
      ],
      [
        -390.5,
        -1885.0,
        899.0
      ],
      [
        -416.5,
        -1885.0,
        899.0
      ],
      [
        -370.5454406738281,
        -1884.5,
        899.0
      ],
      [
        -370.5454406738281,
        -1885.0,
        899.0
      ],
      [
        -370.0,
        -1885.0,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        899.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        895.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        899.0
      ],
      [
        -430.6000061035156,
        -1885.0,
        895.0
      ],
      [
        -430.0,
        -1884.5,
        899.0
      ],
      [
        -430.6000061035156,
        -1885.0,
        899.0
      ],
      [
        -380.0,
        -1885.0,
        895.0
      ],
      [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1884.5,
        899.0
      ],
      [
        -378.5,
        -1885.0,
        906.0
      ],
      [
        -430.6000061035156,
        -1885.0,
        906.0
      ],
      [
        -418.5,
        -1885.0,
        904.5
      ],
      [
        -418.5,
        -1885.0,
        900.5
      ],
      [
        -388.5,
        -1885.0,
        900.5
      ],
      [
        -388.5,
        -1885.0,
        904.5
      ],
      [
        -418.5,
        -1885.0,
        900.5
      ],
      [
        -416.5,
        -1885.0,
        899.0
      ],
      [
        -418.5,
        -1885.0,
        904.5
      ],
      [
        -416.5,
        -1885.0,
        906.0
      ],
      [
        -388.5,
        -1885.0,
        900.5
      ],
      [
        -390.5,
        -1885.0,
        899.0
      ],
      [
        -388.5,
        -1885.0,
        904.5
      ],
      [
        -390.5,
        -1885.0,
        906.0
      ],
      [
        -371.5,
        -1885.0,
        906.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        906.0
      ],
      [
        -358.20001220703125,
        -1886.0,
        895.0
      ],
      [
        -358.20001220703125,
        -1886.0,
        899.0
      ],
      [
        -359.3999938964844,
        -1885.0,
        899.0
      ],
      [
        -431.79998779296875,
        -1886.0,
        895.0
      ],
      [
        -430.6000061035156,
        -1885.0,
        899.0
      ],
      [
        -431.79998779296875,
        -1886.0,
        899.0
      ],
      [
        -370.5454406738281,
        -1886.0,
        899.0
      ],
      [
        -370.5454406738281,
        -1885.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1886.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      [
        -432.734375,
        -1902.85205078125,
        918.5
      ],
      [
        -430.0,
        -1896.0,
        921.0
      ],
      [
        -432.734375,
        -1896.0,
        918.5
      ],
      [
        -436.0,
        -1896.0,
        921.0
      ],
      [
        -437.6666564941406,
        -1903.166748046875,
        918.5
      ],
      [
        -437.6666564941406,
        -1896.0,
        918.5
      ],
      [
        -365.0,
        -1896.0,
        921.0
      ],
      [
        -365.0,
        -1898.528564453125,
        918.5
      ],
      [
        -365.0,
        -1896.0,
        918.5
      ],
      [
        -352.3333435058594,
        -1897.719970703125,
        918.5
      ],
      [
        -354.0,
        -1896.0,
        921.0
      ],
      [
        -352.3333435058594,
        -1896.0,
        918.5
      ],
      [
        -432.734375,
        -1895.0,
        918.5
      ],
      [
        -430.0,
        -1892.65625,
        918.5
      ],
      [
        -435.4541320800781,
        -1892.65625,
        918.5
      ],
      [
        -437.6666564941406,
        -1894.5,
        918.5
      ],
      [
        -437.6666564941406,
        -1894.5,
        918.5
      ],
      [
        -432.734375,
        -1895.0,
        918.5
      ],
      [
        -365.0,
        -1892.65625,
        918.5
      ],
      [
        -365.0,
        -1895.0,
        918.5
      ],
      [
        -365.0,
        -1895.0,
        918.5
      ],
      [
        -352.3333435058594,
        -1894.5,
        918.5
      ],
      [
        -354.5458679199219,
        -1892.65625,
        918.5
      ],
      [
        -352.3333435058594,
        -1894.5,
        918.5
      ],
      [
        -420.5,
        -1887.0,
        898.4998779296875
      ],
      [
        -420.5,
        -1886.0,
        898.5
      ],
      [
        -420.5,
        -1887.0,
        895.0
      ],
      [
        -365.0,
        -1887.0,
        895.0
      ],
      [
        -365.0,
        -1886.0,
        898.5
      ],
      [
        -365.0,
        -1887.0,
        898.4998779296875
      ],
      [
        -420.5,
        -1886.0,
        898.8331909179688
      ],
      [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      [
        -365.0,
        -1888.5,
        895.0
      ],
      [
        -365.0,
        -1888.5,
        897.9998779296875
      ],
      [
        -420.5,
        -1888.5,
        897.9998779296875
      ],
      [
        -420.5,
        -1888.5,
        895.0
      ],
      [
        -365.0,
        -1895.0,
        895.8333129882812
      ],
      [
        -365.0,
        -1895.0,
        895.8333129882812
      ],
      [
        -365.0,
        -1895.661865234375,
        895.6126708984375
      ],
      [
        -348.0,
        -1894.5,
        895.9998168945312
      ],
      [
        -348.0,
        -1894.6202392578125,
        895.959716796875
      ],
      [
        -420.5,
        -1893.5,
        896.3331909179688
      ],
      [
        -440.5,
        -1895.0,
        895.8333129882812
      ],
      [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      [
        -420.5,
        -1893.5,
        896.3331909179688
      ],
      [
        -421.0,
        -1894.5,
        895.9998168945312
      ],
      [
        -442.0,
        -1896.8482666015625,
        912.0
      ],
      [
        -437.6666564941406,
        -1899.2276611328125,
        918.5
      ],
      [
        -415.5,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -411.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -412.5999755859375,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -412.5999755859375,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -405.5,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -401.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -402.5999755859375,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -402.5999755859375,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -395.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -390.5,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -392.0,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -392.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -364.98944091796875,
        -1875.489501953125,
        895.7810668945312
      ],
      [
        -362.01055908203125,
        -1875.489501953125,
        895.7810668945312
      ],
      [
        -362.01055908203125,
        -1875.489501953125,
        895.7810668945312
      ],
      [
        -362.0,
        -1875.0555419921875,
        895.0
      ],
      [
        -365.0,
        -1875.0555419921875,
        895.0
      ],
      [
        -364.98944091796875,
        -1875.489501953125,
        895.7810668945312
      ],
      [
        -416.91241455078125,
        -1850.869873046875,
        910.5170288085938
      ],
      [
        -417.00537109375,
        -1854.1947021484375,
        911.8176879882812
      ],
      [
        -413.7340393066406,
        -1854.7950439453125,
        910.51708984375
      ],
      [
        -413.64111328125,
        -1851.47021484375,
        909.2164916992188
      ],
      [
        -416.3601379394531,
        -1853.6719970703125,
        913.0540771484375
      ],
      [
        -415.4774475097656,
        -1853.8829345703125,
        912.5892944335938
      ],
      [
        -416.3827209472656,
        -1852.7647705078125,
        912.5891723632812
      ],
      [
        -416.3601379394531,
        -1853.6719970703125,
        913.0540771484375
      ],
      [
        -416.269775390625,
        -1850.446044921875,
        911.7919921875
      ],
      [
        -416.34527587890625,
        -1851.425537109375,
        912.065185546875
      ],
      [
        -414.15948486328125,
        -1854.124755859375,
        912.0653076171875
      ],
      [
        -413.18597412109375,
        -1854.2542724609375,
        911.7919921875
      ],
      [
        -415.3869323730469,
        -1850.6495361328125,
        911.3242797851562
      ],
      [
        -416.269775390625,
        -1850.446044921875,
        911.7919921875
      ],
      [
        -413.18597412109375,
        -1854.2542724609375,
        911.7919921875
      ],
      [
        -413.2013244628906,
        -1853.3485107421875,
        911.3242797851562
      ],
      [
        -413.16387939453125,
        -1852.00927734375,
        910.8003540039062
      ],
      [
        -413.0958251953125,
        -1851.0286865234375,
        910.5301513671875
      ],
      [
        -413.0958251953125,
        -1851.0286865234375,
        910.5301513671875
      ],
      [
        -414.0691833496094,
        -1850.891357421875,
        910.8003540039062
      ],
      [
        -414.8298034667969,
        -1854.013916015625,
        912.303466796875
      ],
      [
        -414.15948486328125,
        -1854.124755859375,
        912.0653076171875
      ],
      [
        -415.4774475097656,
        -1853.8829345703125,
        912.5892944335938
      ],
      [
        -414.8298034667969,
        -1854.013916015625,
        912.3034057617188
      ],
      [
        -416.376220703125,
        -1852.1041259765625,
        912.3033447265625
      ],
      [
        -416.3827209472656,
        -1852.7647705078125,
        912.5891723632812
      ],
      [
        -414.54119873046875,
        -1850.63427734375,
        911.4697265625
      ],
      [
        -413.87786865234375,
        -1850.745849609375,
        911.2348022460938
      ],
      [
        -416.34527587890625,
        -1851.425537109375,
        912.065185546875
      ],
      [
        -416.376220703125,
        -1852.1041259765625,
        912.3033447265625
      ],
      [
        -414.73931884765625,
        -1850.778564453125,
        911.0377197265625
      ],
      [
        -415.3869323730469,
        -1850.6495361328125,
        911.3242797851562
      ],
      [
        -414.0691833496094,
        -1850.891357421875,
        910.8003540039062
      ],
      [
        -414.73931884765625,
        -1850.778564453125,
        911.0377197265625
      ],
      [
        -413.2013244628906,
        -1853.3485107421875,
        911.3242797851562
      ],
      [
        -413.1929931640625,
        -1852.688232421875,
        911.0377197265625
      ],
      [
        -413.1929931640625,
        -1852.688232421875,
        911.0377197265625
      ],
      [
        -413.16387939453125,
        -1852.00927734375,
        910.8003540039062
      ],
      [
        -413.01873779296875,
        -1853.1781005859375,
        911.7533569335938
      ],
      [
        -413.0035705566406,
        -1854.07470703125,
        912.2163696289062
      ],
      [
        -413.0035705566406,
        -1854.07470703125,
        912.2163696289062
      ],
      [
        -413.96734619140625,
        -1853.9462890625,
        912.4867553710938
      ],
      [
        -412.914306640625,
        -1850.8817138671875,
        910.96728515625
      ],
      [
        -412.981689453125,
        -1851.8524169921875,
        911.2348022460938
      ],
      [
        -413.87786865234375,
        -1850.745849609375,
        911.2348022460938
      ],
      [
        -412.914306640625,
        -1850.8817138671875,
        910.96728515625
      ],
      [
        -415.271728515625,
        -1853.7069091796875,
        913.0053100585938
      ],
      [
        -416.1452941894531,
        -1853.4981689453125,
        913.46533203125
      ],
      [
        -416.0559387207031,
        -1850.3052978515625,
        912.21630859375
      ],
      [
        -415.1822204589844,
        -1850.5064697265625,
        911.7533569335938
      ],
      [
        -416.1452941894531,
        -1853.4981689453125,
        913.46533203125
      ],
      [
        -416.1677551269531,
        -1852.6002197265625,
        913.0052490234375
      ],
      [
        -416.13067626953125,
        -1851.274658203125,
        912.4867553710938
      ],
      [
        -416.0559387207031,
        -1850.3052978515625,
        912.21630859375
      ],
      [
        -412.981689453125,
        -1851.8524169921875,
        911.2348022460938
      ],
      [
        -413.010498046875,
        -1852.5245361328125,
        911.4697265625
      ],
      [
        -413.010498046875,
        -1852.5245361328125,
        911.4697265625
      ],
      [
        -413.01873779296875,
        -1853.1781005859375,
        911.7533569335938
      ],
      [
        -415.1822204589844,
        -1850.5064697265625,
        911.7533569335938
      ],
      [
        -414.54119873046875,
        -1850.63427734375,
        911.4697265625
      ],
      [
        -413.96734619140625,
        -1853.9462890625,
        912.4867553710938
      ],
      [
        -414.6307678222656,
        -1853.8365478515625,
        912.722412109375
      ],
      [
        -414.6307678222656,
        -1853.8365478515625,
        912.722412109375
      ],
      [
        -415.271728515625,
        -1853.7069091796875,
        913.0053100585938
      ],
      [
        -416.16131591796875,
        -1851.9464111328125,
        912.7223510742188
      ],
      [
        -416.13067626953125,
        -1851.274658203125,
        912.4867553710938
      ],
      [
        -416.1677551269531,
        -1852.6002197265625,
        913.0052490234375
      ],
      [
        -416.16131591796875,
        -1851.9464111328125,
        912.7223510742188
      ],
      [
        -416.4893493652344,
        -1855.1512451171875,
        903.0
      ],
      [
        -416.3656005859375,
        -1854.415771484375,
        903.0
      ],
      [
        -421.16632080078125,
        -1855.7020263671875,
        903.0
      ],
      [
        -420.82513427734375,
        -1853.989501953125,
        903.0
      ],
      [
        -418.64678955078125,
        -1857.9603271484375,
        903.0
      ],
      [
        -416.9585876464844,
        -1857.940673828125,
        903.0
      ],
      [
        -416.96551513671875,
        -1857.9818115234375,
        903.0
      ],
      [
        -417.45367431640625,
        -1853.5072021484375,
        903.0
      ],
      [
        -418.15447998046875,
        -1853.477294921875,
        903.0
      ],
      [
        -420.9310607910156,
        -1857.9310302734375,
        903.0
      ],
      [
        -421.6086120605469,
        -1857.92236328125,
        903.0
      ],
      [
        -421.16632080078125,
        -1855.7020263671875,
        903.0
      ],
      [
        -416.62750244140625,
        -1855.9725341796875,
        903.0
      ],
      [
        -416.4893493652344,
        -1855.1512451171875,
        903.0
      ],
      [
        -416.3656005859375,
        -1854.415771484375,
        903.0
      ],
      [
        -416.5459899902344,
        -1853.5460205078125,
        903.0
      ],
      [
        -416.2216491699219,
        -1853.5599365234375,
        903.0
      ],
      [
        -416.5459899902344,
        -1853.5460205078125,
        903.0
      ],
      [
        -417.45367431640625,
        -1853.5072021484375,
        903.0
      ],
      [
        -420.82513427734375,
        -1853.989501953125,
        903.0
      ],
      [
        -420.70135498046875,
        -1853.3681640625,
        903.0
      ],
      [
        -419.1661376953125,
        -1853.4339599609375,
        903.0
      ],
      [
        -418.64678955078125,
        -1857.9603271484375,
        903.0
      ],
      [
        -420.9310607910156,
        -1857.9310302734375,
        903.0
      ],
      [
        -419.1661376953125,
        -1853.4339599609375,
        903.0
      ],
      [
        -418.15447998046875,
        -1853.477294921875,
        903.0
      ],
      [
        -416.9585876464844,
        -1857.940673828125,
        903.0
      ],
      [
        -416.62750244140625,
        -1855.9725341796875,
        903.0
      ],
      [
        -415.8336181640625,
        -1852.8887939453125,
        904.943603515625
      ],
      [
        -415.4844055175781,
        -1853.320068359375,
        904.943603515625
      ],
      [
        -413.6419982910156,
        -1851.503173828125,
        909.2294921875
      ],
      [
        -413.67352294921875,
        -1851.4642333984375,
        909.2294921875
      ],
      [
        -419.9919738769531,
        -1854.8389892578125,
        905.2894287109375
      ],
      [
        -418.25653076171875,
        -1856.9820556640625,
        905.2894287109375
      ],
      [
        -416.31341552734375,
        -1857.338623046875,
        904.5169677734375
      ],
      [
        -416.2765808105469,
        -1856.0218505859375,
        904.0018310546875
      ],
      [
        -418.6412048339844,
        -1853.101806640625,
        904.0018310546875
      ],
      [
        -419.936767578125,
        -1852.864013671875,
        904.516845703125
      ],
      [
        -415.4844055175781,
        -1853.320068359375,
        904.943603515625
      ],
      [
        -415.8336181640625,
        -1852.8887939453125,
        904.943603515625
      ],
      [
        -418.6412048339844,
        -1853.101806640625,
        904.0018310546875
      ],
      [
        -416.2765808105469,
        -1856.0218505859375,
        904.0018310546875
      ],
      [
        -419.2951965332031,
        -1856.0489501953125,
        907.431396484375
      ],
      [
        -418.25653076171875,
        -1856.9820556640625,
        905.2894287109375
      ],
      [
        -419.9919738769531,
        -1854.8389892578125,
        905.2894287109375
      ],
      [
        -407.02374267578125,
        -1815.2802734375,
        910.6934204101562
      ],
      [
        -411.4316101074219,
        -1834.0316162109375,
        907.197509765625
      ],
      [
        -414.388427734375,
        -1833.4891357421875,
        908.3731079101562
      ],
      [
        -416.0312805175781,
        -1848.0684814453125,
        911.2548828125
      ],
      [
        -409.2714538574219,
        -1814.8680419921875,
        911.5870971679688
      ],
      [
        -414.388427734375,
        -1833.4891357421875,
        908.3731079101562
      ],
      [
        -414.1932678222656,
        -1833.5169677734375,
        908.83154296875
      ],
      [
        -409.09857177734375,
        -1814.9915771484375,
        912.0382080078125
      ],
      [
        -411.46533203125,
        -1834.3709716796875,
        907.2626953125
      ],
      [
        -411.4316101074219,
        -1834.0316162109375,
        907.197509765625
      ],
      [
        -413.0338134765625,
        -1834.7105712890625,
        907.9112548828125
      ],
      [
        -409.09857177734375,
        -1814.9915771484375,
        912.0382080078125
      ],
      [
        -409.2714538574219,
        -1814.8680419921875,
        911.5870971679688
      ],
      [
        -407.02374267578125,
        -1815.2802734375,
        910.6934204101562
      ],
      [
        -406.95672607421875,
        -1815.3348388671875,
        910.9059448242188
      ],
      [
        -411.26666259765625,
        -1834.0538330078125,
        907.66796875
      ],
      [
        -406.8780822753906,
        -1815.3988037109375,
        911.1553344726562
      ],
      [
        -411.5560607910156,
        -1835.283935546875,
        907.43798828125
      ],
      [
        -406.8780822753906,
        -1815.3988037109375,
        911.1553344726562
      ],
      [
        -411.26666259765625,
        -1834.0538330078125,
        907.66796875
      ],
      [
        -412.7045593261719,
        -1848.5238037109375,
        910.4461059570312
      ],
      [
        -412.8839111328125,
        -1848.6466064453125,
        910.0036010742188
      ],
      [
        -416.0312805175781,
        -1848.0684814453125,
        911.2548828125
      ],
      [
        -412.8839111328125,
        -1848.6466064453125,
        910.0036010742188
      ],
      [
        -412.6366882324219,
        -1846.158935546875,
        909.52587890625
      ],
      [
        -412.6866760253906,
        -1846.208251953125,
        909.4096069335938
      ],
      [
        -415.81988525390625,
        -1847.9520263671875,
        911.6846923828125
      ],
      [
        -414.1932678222656,
        -1833.5169677734375,
        908.83154296875
      ],
      [
        -415.81988525390625,
        -1847.9520263671875,
        911.6846923828125
      ],
      [
        -412.7045593261719,
        -1848.5238037109375,
        910.4461059570312
      ],
      [
        -416.7771911621094,
        -1846.031982421875,
        908.62451171875
      ],
      [
        -413.51690673828125,
        -1847.0267333984375,
        907.478271484375
      ],
      [
        -412.9063720703125,
        -1846.4248046875,
        908.8985595703125
      ],
      [
        -412.9063720703125,
        -1846.4248046875,
        908.8985595703125
      ],
      [
        -413.1583557128906,
        -1846.6732177734375,
        908.3124389648438
      ],
      [
        -413.1583557128906,
        -1846.6732177734375,
        908.3124389648438
      ],
      [
        -413.51690673828125,
        -1847.0267333984375,
        907.478271484375
      ],
      [
        -415.7038879394531,
        -1845.162841796875,
        910.6805419921875
      ],
      [
        -416.1236572265625,
        -1845.502685546875,
        909.8764038085938
      ],
      [
        -416.1236572265625,
        -1845.502685546875,
        909.8764038085938
      ],
      [
        -416.41851806640625,
        -1845.741455078125,
        909.3115844726562
      ],
      [
        -416.7771911621094,
        -1846.031982421875,
        908.62451171875
      ],
      [
        -416.41851806640625,
        -1845.741455078125,
        909.3115844726562
      ],
      [
        -419.0276184082031,
        -1850.68505859375,
        905.601806640625
      ],
      [
        -419.37286376953125,
        -1850.9647216796875,
        904.9405517578125
      ],
      [
        -418.2526550292969,
        -1850.0574951171875,
        904.9036865234375
      ],
      [
        -416.8581237792969,
        -1848.9283447265625,
        909.7576293945312
      ],
      [
        -419.0276184082031,
        -1850.68505859375,
        905.601806640625
      ],
      [
        -418.2526550292969,
        -1850.0574951171875,
        904.9036865234375
      ],
      [
        -418.1640319824219,
        -1853.0655517578125,
        904.161865234375
      ],
      [
        -418.53302001953125,
        -1842.484375,
        903.0
      ],
      [
        -418.9314270019531,
        -1844.484375,
        903.0
      ],
      [
        -418.9314270019531,
        -1844.484375,
        903.0
      ],
      [
        -419.6276550292969,
        -1847.97900390625,
        903.0
      ],
      [
        -414.7251892089844,
        -1844.6639404296875,
        903.0
      ],
      [
        -416.15325927734375,
        -1853.1533203125,
        903.0
      ],
      [
        -416.15325927734375,
        -1853.1533203125,
        903.0
      ],
      [
        -420.4572448730469,
        -1852.142822265625,
        903.0
      ],
      [
        -420.4572448730469,
        -1852.142822265625,
        903.0
      ],
      [
        -419.6276550292969,
        -1847.97900390625,
        903.0
      ],
      [
        -418.53302001953125,
        -1842.484375,
        903.0
      ],
      [
        -421.10009765625,
        -1842.484375,
        897.1367797851562
      ],
      [
        -417.22711181640625,
        -1842.484375,
        895.0
      ],
      [
        -414.5,
        -1842.484375,
        902.6055297851562
      ],
      [
        -422.1572570800781,
        -1843.0947265625,
        895.0
      ],
      [
        -421.10009765625,
        -1842.484375,
        897.1367797851562
      ],
      [
        -414.37109375,
        -1842.558837890625,
        903.0
      ],
      [
        -414.5,
        -1842.484375,
        902.6055297851562
      ],
      [
        -419.82037353515625,
        -1851.3271484375,
        904.0833740234375
      ],
      [
        -419.89996337890625,
        -1851.54736328125,
        904.0018310546875
      ],
      [
        -419.89996337890625,
        -1851.54736328125,
        904.0018310546875
      ],
      [
        -419.82037353515625,
        -1851.3271484375,
        904.0833740234375
      ],
      [
        -414.37109375,
        -1842.558837890625,
        903.0
      ],
      [
        -413.8059387207031,
        -1843.4625244140625,
        905.0
      ],
      [
        -414.7251892089844,
        -1844.6639404296875,
        903.0
      ],
      [
        -413.98297119140625,
        -1844.514892578125,
        905.0
      ],
      [
        -413.8059387207031,
        -1843.4625244140625,
        905.0
      ],
      [
        -413.98297119140625,
        -1844.514892578125,
        905.0
      ],
      [
        -419.5396423339844,
        -1847.537109375,
        903.0
      ],
      [
        -419.16619873046875,
        -1848.8671875,
        904.4581298828125
      ],
      [
        -419.92742919921875,
        -1849.483642578125,
        903.0
      ],
      [
        -419.16619873046875,
        -1848.8671875,
        904.4581298828125
      ],
      [
        -421.89556884765625,
        -1853.2972412109375,
        913.7618408203125
      ],
      [
        -441.25640869140625,
        -1843.00146484375,
        937.160888671875
      ],
      [
        -430.67498779296875,
        -1849.6146240234375,
        922.0758666992188
      ],
      [
        -419.3368225097656,
        -1834.8275146484375,
        910.8987426757812
      ],
      [
        -414.5292053222656,
        -1834.7386474609375,
        908.6200561523438
      ],
      [
        -419.3368225097656,
        -1834.8275146484375,
        910.8987426757812
      ],
      [
        -421.4009094238281,
        -1834.4395751953125,
        912.007080078125
      ],
      [
        -424.7510681152344,
        -1837.4610595703125,
        914.4225463867188
      ],
      [
        -424.7510681152344,
        -1837.4610595703125,
        914.4225463867188
      ],
      [
        -426.64044189453125,
        -1837.943115234375,
        915.7784423828125
      ],
      [
        -428.452392578125,
        -1842.2095947265625,
        917.9464721679688
      ],
      [
        -428.452392578125,
        -1842.2095947265625,
        917.9464721679688
      ],
      [
        -429.864013671875,
        -1843.4764404296875,
        919.3760375976562
      ],
      [
        -429.8774108886719,
        -1848.350341796875,
        920.9341430664062
      ],
      [
        -429.8774108886719,
        -1848.350341796875,
        920.9341430664062
      ],
      [
        -430.67498779296875,
        -1849.6146240234375,
        922.0758666992188
      ],
      [
        -430.3904113769531,
        -1849.6959228515625,
        921.8948974609375
      ],
      [
        -441.06365966796875,
        -1842.9542236328125,
        937.2764282226562
      ],
      [
        -441.25640869140625,
        -1843.00146484375,
        937.160888671875
      ],
      [
        -430.3176574707031,
        -1849.481201171875,
        922.3975219726562
      ],
      [
        -440.837890625,
        -1842.89892578125,
        937.4118041992188
      ],
      [
        -429.6241149902344,
        -1849.9150390625,
        921.4075927734375
      ],
      [
        -440.837890625,
        -1842.89892578125,
        937.4118041992188
      ],
      [
        -429.7685241699219,
        -1847.881103515625,
        920.7058715820312
      ],
      [
        -428.73394775390625,
        -1848.668212890625,
        920.2031860351562
      ],
      [
        -418.9993591308594,
        -1836.1793212890625,
        910.9351196289062
      ],
      [
        -419.7505187988281,
        -1835.0286865234375,
        911.16796875
      ],
      [
        -428.73394775390625,
        -1848.668212890625,
        920.2031860351562
      ],
      [
        -421.6387939453125,
        -1852.197998046875,
        916.3295288085938
      ],
      [
        -418.4098815917969,
        -1853.12109375,
        914.2761840820312
      ],
      [
        -418.9993591308594,
        -1836.1793212890625,
        910.9351196289062
      ],
      [
        -415.5633544921875,
        -1843.916015625,
        910.43408203125
      ],
      [
        -418.4098815917969,
        -1853.12109375,
        914.2761840820312
      ],
      [
        -415.7430419921875,
        -1845.194580078125,
        910.6055297851562
      ],
      [
        -422.3187561035156,
        -1850.5194091796875,
        916.1235961914062
      ],
      [
        -420.97357177734375,
        -1852.3880615234375,
        915.9063720703125
      ],
      [
        -421.0234375,
        -1852.437255859375,
        915.7903442382812
      ],
      [
        -422.3187561035156,
        -1850.5194091796875,
        916.1235961914062
      ],
      [
        -416.4612121582031,
        -1845.776123046875,
        910.8529052734375
      ],
      [
        -415.8730773925781,
        -1845.2998046875,
        910.3564453125
      ],
      [
        -416.4612121582031,
        -1845.776123046875,
        910.8529052734375
      ],
      [
        -422.36932373046875,
        -1850.5604248046875,
        915.8401489257812
      ],
      [
        -422.4280090332031,
        -1850.60791015625,
        915.8896484375
      ],
      [
        -422.36932373046875,
        -1850.5604248046875,
        915.8401489257812
      ],
      [
        -422.4280090332031,
        -1850.60791015625,
        915.8896484375
      ],
      [
        -421.1510314941406,
        -1852.56298828125,
        915.49365234375
      ],
      [
        -421.327880859375,
        -1852.7374267578125,
        915.0823364257812
      ],
      [
        -421.327880859375,
        -1852.7374267578125,
        915.0823364257812
      ],
      [
        -421.57666015625,
        -1852.9827880859375,
        914.503662109375
      ],
      [
        -421.89556884765625,
        -1853.2972412109375,
        913.7618408203125
      ],
      [
        -421.57666015625,
        -1852.9827880859375,
        914.503662109375
      ],
      [
        -418.17401123046875,
        -1852.9527587890625,
        914.6748657226562
      ],
      [
        -430.3176574707031,
        -1849.481201171875,
        922.3975219726562
      ],
      [
        -418.17401123046875,
        -1852.9527587890625,
        914.6748657226562
      ],
      [
        -430.11572265625,
        -1857.8133544921875,
        903.0
      ],
      [
        -430.11572265625,
        -1858.10009765625,
        902.3323364257812
      ],
      [
        -429.09490966796875,
        -1857.826416015625,
        903.0
      ],
      [
        -427.95574951171875,
        -1857.841064453125,
        903.0
      ],
      [
        -427.95574951171875,
        -1857.841064453125,
        903.0
      ],
      [
        -428.2840881347656,
        -1861.2723388671875,
        895.0
      ],
      [
        -430.11572265625,
        -1858.10009765625,
        902.3323364257812
      ],
      [
        -417.6201477050781,
        -1854.081787109375,
        912.0621337890625
      ],
      [
        -419.4624938964844,
        -1855.898681640625,
        907.7763671875
      ],
      [
        -419.4624938964844,
        -1855.898681640625,
        907.7763671875
      ],
      [
        -430.11572265625,
        -1857.8133544921875,
        903.0
      ],
      [
        -429.6155090332031,
        -1856.9609375,
        905.0
      ],
      [
        -428.4011535644531,
        -1857.344970703125,
        904.1417236328125
      ],
      [
        -428.61572265625,
        -1856.9737548828125,
        905.0
      ],
      [
        -429.6155090332031,
        -1856.9609375,
        905.0
      ],
      [
        -428.61572265625,
        -1856.9737548828125,
        905.0
      ],
      [
        -429.09490966796875,
        -1857.826416015625,
        903.0
      ],
      [
        -428.4011535644531,
        -1857.344970703125,
        904.1417236328125
      ],
      [
        -428.80889892578125,
        -1854.94873046875,
        922.9303588867188
      ],
      [
        -429.6240234375,
        -1849.9150390625,
        921.4075317382812
      ],
      [
        -428.80889892578125,
        -1854.94873046875,
        922.9303588867188
      ],
      [
        -428.6824035644531,
        -1857.0799560546875,
        923.9683837890625
      ],
      [
        -438.2117004394531,
        -1856.866455078125,
        940.98193359375
      ],
      [
        -425.4097900390625,
        -1861.0003662109375,
        923.6314086914062
      ],
      [
        -425.4097900390625,
        -1861.0003662109375,
        923.6314086914062
      ],
      [
        -424.4577941894531,
        -1863.0802001953125,
        924.2645263671875
      ],
      [
        -430.8908386230469,
        -1868.34765625,
        941.9049072265625
      ],
      [
        -418.2311706542969,
        -1857.174072265625,
        906.2737426757812
      ],
      [
        -418.5262756347656,
        -1856.73974609375,
        905.845703125
      ],
      [
        -418.8973693847656,
        -1856.4063720703125,
        906.6109619140625
      ],
      [
        -420.1971435546875,
        -1865.5833740234375,
        922.9303588867188
      ],
      [
        -420.1971435546875,
        -1865.5833740234375,
        922.9303588867188
      ],
      [
        -418.5484924316406,
        -1867.283935546875,
        923.0947265625
      ],
      [
        -420.24615478515625,
        -1876.695068359375,
        940.0906982421875
      ],
      [
        -417.44744873046875,
        -1858.3870849609375,
        907.7763671875
      ],
      [
        -417.1952209472656,
        -1858.6986083984375,
        907.7763671875
      ],
      [
        -419.037841796875,
        -1856.2801513671875,
        906.900634765625
      ],
      [
        -417.0255126953125,
        -1858.8408203125,
        907.8468627929688
      ],
      [
        -417.1952209472656,
        -1858.6986083984375,
        907.7763671875
      ],
      [
        -417.44744873046875,
        -1858.3870849609375,
        907.7763671875
      ],
      [
        -408.85107421875,
        -1880.655029296875,
        936.26708984375
      ],
      [
        -412.4106750488281,
        -1869.0601806640625,
        920.9002075195312
      ],
      [
        -413.965087890625,
        -1868.000244140625,
        920.93408203125
      ],
      [
        -413.965087890625,
        -1868.0003662109375,
        920.93408203125
      ],
      [
        -412.4106750488281,
        -1869.0601806640625,
        920.9002075195312
      ],
      [
        -412.4266662597656,
        -1868.7657470703125,
        920.717529296875
      ],
      [
        -408.7774658203125,
        -1880.47412109375,
        936.3875732421875
      ],
      [
        -408.85107421875,
        -1880.655029296875,
        936.26708984375
      ],
      [
        -416.08929443359375,
        -1859.2431640625,
        908.6363525390625
      ],
      [
        -416.2085266113281,
        -1859.3397216796875,
        908.3810424804688
      ],
      [
        -417.2024230957031,
        -1858.650634765625,
        907.8173217773438
      ],
      [
        -418.15692138671875,
        -1857.510986328125,
        907.7763671875
      ],
      [
        -418.15692138671875,
        -1857.510986328125,
        907.7763671875
      ],
      [
        -418.5894775390625,
        -1856.8741455078125,
        907.1475219726562
      ],
      [
        -416.2085266113281,
        -1859.3397216796875,
        908.3810424804688
      ],
      [
        -416.08929443359375,
        -1859.2431640625,
        908.6363525390625
      ],
      [
        -415.5345458984375,
        -1858.7939453125,
        907.3717651367188
      ],
      [
        -415.5568542480469,
        -1858.81201171875,
        907.3180541992188
      ],
      [
        -412.2359619140625,
        -1868.7327880859375,
        921.23388671875
      ],
      [
        -408.69110107421875,
        -1880.261962890625,
        936.5289306640625
      ],
      [
        -412.4697265625,
        -1867.97265625,
        920.225341796875
      ],
      [
        -408.69110107421875,
        -1880.261962890625,
        936.5289306640625
      ],
      [
        -415.9762268066406,
        -1859.151611328125,
        908.8784790039062
      ],
      [
        -417.26202392578125,
        -1858.2607421875,
        908.1485595703125
      ],
      [
        -415.9762268066406,
        -1859.151611328125,
        908.8784790039062
      ],
      [
        -415.34014892578125,
        -1858.636474609375,
        907.840087890625
      ],
      [
        -413.8913269042969,
        -1860.4229736328125,
        912.7186889648438
      ],
      [
        -427.7413024902344,
        -1854.7611083984375,
        922.0418701171875
      ],
      [
        -428.547607421875,
        -1855.4139404296875,
        922.9842529296875
      ],
      [
        -414.44183349609375,
        -1867.8153076171875,
        921.0867919921875
      ],
      [
        -414.0383605957031,
        -1866.81494140625,
        920.20263671875
      ],
      [
        -414.03826904296875,
        -1866.8165283203125,
        920.2035522460938
      ],
      [
        -412.9183044433594,
        -1859.7103271484375,
        915.09814453125
      ],
      [
        -413.0997314453125,
        -1856.368896484375,
        913.0245971679688
      ],
      [
        -427.7413024902344,
        -1854.7611083984375,
        922.0418701171875
      ],
      [
        -421.9015197753906,
        -1852.122802734375,
        916.49658203125
      ],
      [
        -413.0997314453125,
        -1856.368896484375,
        913.0245971679688
      ],
      [
        -421.0084228515625,
        -1852.4224853515625,
        915.8253173828125
      ],
      [
        -414.1083984375,
        -1860.5986328125,
        916.1864624023438
      ],
      [
        -412.92218017578125,
        -1859.6380615234375,
        915.0532836914062
      ],
      [
        -412.9716796875,
        -1859.6781005859375,
        914.93408203125
      ],
      [
        -414.1083984375,
        -1860.5986328125,
        916.1864624023438
      ],
      [
        -414.52239990234375,
        -1860.3526611328125,
        915.9086303710938
      ],
      [
        -414.2309875488281,
        -1860.6978759765625,
        915.9239501953125
      ],
      [
        -414.52239990234375,
        -1860.3526611328125,
        915.9086303710938
      ],
      [
        -414.2309875488281,
        -1860.6978759765625,
        915.9239501953125
      ],
      [
        -413.10638427734375,
        -1859.7872314453125,
        914.6095581054688
      ],
      [
        -420.517578125,
        -1853.2501220703125,
        915.5933837890625
      ],
      [
        -421.121826171875,
        -1852.5343017578125,
        915.5615844726562
      ],
      [
        -420.517578125,
        -1853.2501220703125,
        915.5933837890625
      ],
      [
        -413.3841247558594,
        -1860.01220703125,
        913.9404296875
      ],
      [
        -413.3841247558594,
        -1860.01220703125,
        913.9404296875
      ],
      [
        -413.6191711425781,
        -1860.2025146484375,
        913.3743286132812
      ],
      [
        -413.6191711425781,
        -1860.2025146484375,
        913.3743286132812
      ],
      [
        -413.8913269042969,
        -1860.4229736328125,
        912.7186889648438
      ],
      [
        -413.80670166015625,
        -1857.394775390625,
        911.5341796875
      ],
      [
        -412.9181823730469,
        -1856.1678466796875,
        913.4364624023438
      ],
      [
        -412.2359619140625,
        -1868.7327880859375,
        921.23388671875
      ],
      [
        -412.9181823730469,
        -1856.1678466796875,
        913.4364624023438
      ],
      [
        -415.9927062988281,
        -1859.1649169921875,
        907.3911743164062
      ],
      [
        -415.6397705078125,
        -1858.879150390625,
        907.1182861328125
      ],
      [
        -415.7530517578125,
        -1858.9708251953125,
        906.8453979492188
      ],
      [
        -415.6397705078125,
        -1858.879150390625,
        907.1182861328125
      ],
      [
        -415.9927062988281,
        -1859.1649169921875,
        907.3911743164062
      ],
      [
        -416.3213195800781,
        -1859.4310302734375,
        908.1394653320312
      ],
      [
        -416.3213195800781,
        -1859.4310302734375,
        908.1394653320312
      ],
      [
        -416.4160461425781,
        -1859.5076904296875,
        906.8385620117188
      ],
      [
        -418.4624938964844,
        -1856.7969970703125,
        905.7141723632812
      ],
      [
        -416.3407897949219,
        -1858.318115234375,
        904.9000854492188
      ],
      [
        -417.7560119628906,
        -1857.0738525390625,
        905.0904541015625
      ],
      [
        -416.10650634765625,
        -1859.257080078125,
        905.9939575195312
      ],
      [
        -416.4160461425781,
        -1859.5076904296875,
        906.8385620117188
      ],
      [
        -416.3096008300781,
        -1859.4215087890625,
        905.5046997070312
      ],
      [
        -416.3686218261719,
        -1859.3134765625,
        905.2894287109375
      ],
      [
        -416.3686218261719,
        -1859.3134765625,
        905.2894287109375
      ],
      [
        -416.3096008300781,
        -1859.4215087890625,
        905.5046997070312
      ],
      [
        -421.10009765625,
        -1867.11572265625,
        895.7542114257812
      ],
      [
        -421.3465881347656,
        -1866.973388671875,
        895.0
      ],
      [
        -418.5019836425781,
        -1867.1156005859375,
        903.0
      ],
      [
        -418.1655578613281,
        -1865.11572265625,
        903.0
      ],
      [
        -418.1655578613281,
        -1865.11572265625,
        903.0
      ],
      [
        -418.5019836425781,
        -1867.1156005859375,
        903.0
      ],
      [
        -421.10009765625,
        -1867.11572265625,
        895.7542114257812
      ],
      [
        -364.099853515625,
        -1874.9783935546875,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1873.021728515625,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1873.021728515625,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1874.9783935546875,
        933.60009765625
      ],
      [
        -364.4751892089844,
        -1874.9752197265625,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1873.02490234375,
        933.8346557617188
      ],
      [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      [
        -364.476318359375,
        -1884.9921875,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1874.9822998046875,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1874.9822998046875,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1884.990478515625,
        933.8345336914062
      ],
      [
        -364.476318359375,
        -1884.9921875,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1884.990478515625,
        933.8345336914062
      ],
      [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      [
        -403.8706970214844,
        -1872.8739013671875,
        922.6615600585938
      ],
      [
        -411.2259521484375,
        -1872.919189453125,
        926.0146484375
      ],
      [
        -364.6609802246094,
        -1873.0264892578125,
        933.9508056640625
      ],
      [
        -364.6609802246094,
        -1873.0264892578125,
        933.9508056640625
      ],
      [
        -372.5899963378906,
        -1873.0933837890625,
        938.9066162109375
      ],
      [
        -403.8706970214844,
        -1872.8739013671875,
        922.6615600585938
      ],
      [
        -390.618408203125,
        -1872.858154296875,
        921.4956665039062
      ],
      [
        -403.46282958984375,
        -1872.8837890625,
        923.3911743164062
      ],
      [
        -410.94549560546875,
        -1872.929931640625,
        926.8019409179688
      ],
      [
        -390.052734375,
        -1872.867919921875,
        922.2172241210938
      ],
      [
        -403.46282958984375,
        -1872.8837890625,
        923.3911743164062
      ],
      [
        -390.618408203125,
        -1872.858154296875,
        921.4956665039062
      ],
      [
        -385.58837890625,
        -1873.6688232421875,
        922.7626953125
      ],
      [
        -386.88201904296875,
        -1872.8642578125,
        921.9398193359375
      ],
      [
        -385.58837890625,
        -1873.6688232421875,
        922.7626953125
      ],
      [
        -385.2518005371094,
        -1872.8756103515625,
        922.7907104492188
      ],
      [
        -390.052734375,
        -1872.867919921875,
        922.2172241210938
      ],
      [
        -385.2518005371094,
        -1872.8756103515625,
        922.7907104492188
      ],
      [
        -384.96356201171875,
        -1872.8673095703125,
        922.1678466796875
      ],
      [
        -384.96356201171875,
        -1872.8673095703125,
        922.1678466796875
      ],
      [
        -364.60009765625,
        -1873.0108642578125,
        932.7999267578125
      ],
      [
        -364.8807678222656,
        -1873.01318359375,
        932.975341796875
      ],
      [
        -364.8807678222656,
        -1873.01318359375,
        932.975341796875
      ],
      [
        -373.0906066894531,
        -1873.0826416015625,
        938.106689453125
      ],
      [
        -364.4901123046875,
        -1875.0,
        932.7311401367188
      ],
      [
        -373.0906066894531,
        -1873.0826416015625,
        938.106689453125
      ],
      [
        -372.5899963378906,
        -1873.0933837890625,
        938.9066162109375
      ],
      [
        -364.60009765625,
        -1873.0108642578125,
        932.7999267578125
      ],
      [
        -364.099853515625,
        -1834.478271484375,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1832.521728515625,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1832.521728515625,
        933.60009765625
      ],
      [
        -364.099853515625,
        -1834.478271484375,
        933.60009765625
      ],
      [
        -364.4751892089844,
        -1834.47509765625,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1832.52490234375,
        933.8346557617188
      ],
      [
        -364.4867248535156,
        -1873.0,
        932.9812622070312
      ],
      [
        -364.476318359375,
        -1863.0078125,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1873.02490234375,
        933.8346557617188
      ],
      [
        -364.4751892089844,
        -1873.0177001953125,
        933.8346557617188
      ],
      [
        -364.4751892089844,
        -1873.0177001953125,
        933.8346557617188
      ],
      [
        -364.4751892089844,
        -1863.009521484375,
        933.8345336914062
      ],
      [
        -364.476318359375,
        -1863.0078125,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1863.009521484375,
        933.8345336914062
      ],
      [
        -364.4867248535156,
        -1834.5,
        932.9812622070312
      ],
      [
        -364.476318359375,
        -1844.4921875,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1834.4822998046875,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1834.4822998046875,
        933.834716796875
      ],
      [
        -364.4751892089844,
        -1844.490478515625,
        933.8345336914062
      ],
      [
        -364.476318359375,
        -1844.4921875,
        933.7521362304688
      ],
      [
        -364.4751892089844,
        -1844.490478515625,
        933.8345336914062
      ],
      [
        -364.4867248535156,
        -1834.5,
        932.9812622070312
      ],
      [
        -364.4867248535156,
        -1873.0,
        932.9812622070312
      ],
      [
        -383.56573486328125,
        -1832.1502685546875,
        906.1185913085938
      ],
      [
        -389.77178955078125,
        -1832.141357421875,
        905.454345703125
      ],
      [
        -398.5466003417969,
        -1860.5015869140625,
        910.8987426757812
      ],
      [
        -397.12152099609375,
        -1854.3607177734375,
        907.9112548828125
      ],
      [
        -398.5963439941406,
        -1862.601806640625,
        912.0073852539062
      ],
      [
        -398.5466003417969,
        -1860.5015869140625,
        910.8987426757812
      ],
      [
        -397.12152099609375,
        -1854.3607177734375,
        907.9112548828125
      ],
      [
        -396.21826171875,
        -1852.3533935546875,
        907.0216064453125
      ],
      [
        -380.715576171875,
        -1867.4173583984375,
        918.1234741210938
      ],
      [
        -377.0277404785156,
        -1851.524169921875,
        910.3916015625
      ],
      [
        -398.1900634765625,
        -1847.7623291015625,
        905.9151000976562
      ],
      [
        -398.1900634765625,
        -1847.7623291015625,
        905.9151000976562
      ],
      [
        -398.1166687011719,
        -1845.4693603515625,
        905.3049926757812
      ],
      [
        -379.9106750488281,
        -1838.6571044921875,
        906.872314453125
      ],
      [
        -393.769775390625,
        -1872.8619384765625,
        921.7728881835938
      ],
      [
        -403.1121520996094,
        -1866.9979248046875,
        915.7783203125
      ],
      [
        -402.247802734375,
        -1865.250244140625,
        914.422607421875
      ],
      [
        -403.1121520996094,
        -1866.9979248046875,
        915.7783203125
      ],
      [
        -402.247802734375,
        -1865.250244140625,
        914.422607421875
      ],
      [
        -389.77178955078125,
        -1832.141357421875,
        905.454345703125
      ],
      [
        -403.7577209472656,
        -1832.1473388671875,
        905.9053955078125
      ],
      [
        -389.7801818847656,
        -1832.1480712890625,
        905.9517211914062
      ],
      [
        -383.5889587402344,
        -1832.1571044921875,
        906.6171264648438
      ],
      [
        -383.5889587402344,
        -1832.1571044921875,
        906.6171264648438
      ],
      [
        -383.56573486328125,
        -1832.1502685546875,
        906.1185913085938
      ],
      [
        -401.58929443359375,
        -1841.7109375,
        905.2142333984375
      ],
      [
        -401.58929443359375,
        -1841.7109375,
        905.2142333984375
      ],
      [
        -402.3418884277344,
        -1839.4686279296875,
        905.0089111328125
      ],
      [
        -364.6609802246094,
        -1832.5264892578125,
        933.9508056640625
      ],
      [
        -364.6609802246094,
        -1832.5264892578125,
        933.9508056640625
      ],
      [
        -372.5899963378906,
        -1832.5933837890625,
        938.9066162109375
      ],
      [
        -364.60009765625,
        -1832.5108642578125,
        932.7999267578125
      ],
      [
        -364.8807678222656,
        -1832.51318359375,
        932.975341796875
      ],
      [
        -364.8807678222656,
        -1832.51318359375,
        932.975341796875
      ],
      [
        -373.0906066894531,
        -1832.5826416015625,
        938.106689453125
      ],
      [
        -364.4901123046875,
        -1834.5,
        932.7311401367188
      ],
      [
        -372.5899963378906,
        -1832.5933837890625,
        938.9066162109375
      ],
      [
        -373.0906066894531,
        -1832.5826416015625,
        938.106689453125
      ],
      [
        -364.4901123046875,
        -1873.0,
        932.73046875
      ],
      [
        -409.1952209472656,
        -1869.0006103515625,
        919.3761596679688
      ],
      [
        -405.948974609375,
        -1872.88671875,
        923.6090087890625
      ],
      [
        -407.66229248046875,
        -1867.883056640625,
        917.9464721679688
      ],
      [
        -409.1952209472656,
        -1869.0006103515625,
        919.3761596679688
      ],
      [
        -407.66229248046875,
        -1867.883056640625,
        917.9464721679688
      ],
      [
        -403.6466979980469,
        -1832.154052734375,
        906.3942260742188
      ],
      [
        -389.7801818847656,
        -1832.1480712890625,
        905.9517211914062
      ],
      [
        -406.8018798828125,
        -1837.1279296875,
        905.9151611328125
      ],
      [
        -403.7577209472656,
        -1832.1473388671875,
        905.9053955078125
      ],
      [
        -406.2877197265625,
        -1832.1551513671875,
        906.478515625
      ],
      [
        -408.2506408691406,
        -1835.265380859375,
        906.1786499023438
      ],
      [
        -406.8018798828125,
        -1837.1279296875,
        905.9151611328125
      ],
      [
        -408.2506408691406,
        -1835.265380859375,
        906.1786499023438
      ],
      [
        -412.4697265625,
        -1867.9722900390625,
        920.22509765625
      ],
      [
        -410.993896484375,
        -1832.1695556640625,
        907.544677734375
      ],
      [
        -364.60009765625,
        -1832.5108642578125,
        932.7999267578125
      ],
      [
        -410.82489013671875,
        -1832.1759033203125,
        908.01904296875
      ],
      [
        -403.6466979980469,
        -1832.154052734375,
        906.3942260742188
      ],
      [
        -411.5560607910156,
        -1835.2840576171875,
        907.43798828125
      ],
      [
        -398.10821533203125,
        -1848.2677001953125,
        906.0679931640625
      ],
      [
        -399.4720458984375,
        -1848.1259765625,
        906.3333740234375
      ],
      [
        -403.2135314941406,
        -1864.2794189453125,
        914.1903686523438
      ],
      [
        -401.9659118652344,
        -1864.8885498046875,
        914.1542358398438
      ],
      [
        -409.2225341796875,
        -1856.64208984375,
        911.7911376953125
      ],
      [
        -407.97991943359375,
        -1851.9580078125,
        909.4751586914062
      ],
      [
        -406.13580322265625,
        -1854.142578125,
        909.5720825195312
      ],
      [
        -407.1474914550781,
        -1854.9617919921875,
        910.0394287109375
      ],
      [
        -408.07952880859375,
        -1855.716552734375,
        910.8262329101562
      ],
      [
        -408.07952880859375,
        -1855.716552734375,
        910.8262329101562
      ],
      [
        -406.13580322265625,
        -1854.142578125,
        909.5720825195312
      ],
      [
        -406.6619873046875,
        -1853.519287109375,
        909.54443359375
      ],
      [
        -406.6619873046875,
        -1853.519287109375,
        909.54443359375
      ],
      [
        -412.9649658203125,
        -1859.6727294921875,
        914.9502563476562
      ],
      [
        -407.9609375,
        -1855.6204833984375,
        910.4152221679688
      ],
      [
        -407.9609375,
        -1855.6204833984375,
        910.4152221679688
      ],
      [
        -409.183837890625,
        -1856.61083984375,
        910.980224609375
      ],
      [
        -409.183837890625,
        -1856.61083984375,
        910.980224609375
      ],
      [
        -413.73931884765625,
        -1860.2998046875,
        913.0848999023438
      ],
      [
        -412.6650695800781,
        -1846.1868896484375,
        909.4598999023438
      ],
      [
        -412.7666320800781,
        -1846.2869873046875,
        909.2236328125
      ],
      [
        -412.3203430175781,
        -1846.8157958984375,
        909.2470703125
      ],
      [
        -412.3203430175781,
        -1846.8157958984375,
        909.2470703125
      ],
      [
        -362.4242858886719,
        -1776.7664794921875,
        926.3948364257812
      ],
      [
        -362.49530029296875,
        -1778.702880859375,
        931.6506958007812
      ],
      [
        -362.5135498046875,
        -1779.199951171875,
        933.0
      ],
      [
        -362.49530029296875,
        -1778.702880859375,
        931.6506958007812
      ],
      [
        -362.5135498046875,
        -1775.8438720703125,
        933.0
      ],
      [
        -362.5135498046875,
        -1778.5045166015625,
        933.0
      ],
      [
        -362.5135498046875,
        -1778.5045166015625,
        933.0
      ],
      [
        -362.5135498046875,
        -1779.199951171875,
        933.0
      ],
      [
        -363.3201904296875,
        -1832.5,
        932.0
      ],
      [
        -394.0953063964844,
        -1821.1407470703125,
        906.8723754882812
      ],
      [
        -384.386474609375,
        -1830.689208984375,
        905.9493408203125
      ],
      [
        -386.1943054199219,
        -1832.146484375,
        905.8372802734375
      ],
      [
        -384.386474609375,
        -1830.689208984375,
        905.9493408203125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -986.5693359375,
        -3919.642822265625,
        443.0972900390625
      ],
      "bbox_max": [
        569.706298828125,
        -1739.924072265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -986.5693359375,
        -2820.1337890625,
        443.0972900390625
      ],
      "bbox_max": [
        -482.3701171875,
        -2127.7587890625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -986.5693359375,
        -2819.0322265625,
        443.0972900390625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2127.7587890625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -986.5693359375,
        -2819.0322265625,
        558.2156982421875
      ],
      "bbox_max": [
        -495.6846008300781,
        -2127.7587890625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -986.5693359375,
        -2819.0322265625,
        558.2156982421875
      ],
      "bbox_max": [
        -495.6846008300781,
        -2127.7587890625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -986.5693359375,
        -2819.0322265625,
        650.2186279296875
      ],
      "bbox_max": [
        -495.6846008300781,
        -2127.7587890625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -986.5693359375,
        -2819.0322265625,
        722.3209228515625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2139.422607421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -986.5693359375,
        -2816.75732421875,
        722.3209228515625
      ],
      "bbox_max": [
        -498.223876953125,
        -2139.422607421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -986.5693359375,
        -2549.36376953125,
        722.3209228515625
      ],
      "bbox_max": [
        -594.252197265625,
        -2139.422607421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -986.5693359375,
        -2549.36376953125,
        722.3209228515625
      ],
      "bbox_max": [
        -594.252197265625,
        -2139.422607421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -986.5693359375,
        -2430.738037109375,
        722.3209228515625
      ],
      "bbox_max": [
        -732.18115234375,
        -2139.422607421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -754.6883544921875,
        -2430.738037109375,
        1442.865478515625
      ],
      "bbox_max": [
        -732.18115234375,
        -2359.7060546875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -511.1015625,
        -2816.75732421875,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -502.13018798828125,
        -2819.0322265625,
        1386.6339111328125
      ],
      "bbox_max": [
        -495.6846008300781,
        -2806.955322265625,
        1479.1107177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -974.8027954101562,
        -2408.3671875,
        650.2186279296875
      ],
      "bbox_max": [
        -685.0712890625,
        -2127.7587890625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -974.8027954101562,
        -2408.3671875,
        650.2186279296875
      ],
      "bbox_max": [
        -685.0712890625,
        -2127.7587890625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -860.804443359375,
        -2408.3671875,
        686.6377563476562
      ],
      "bbox_max": [
        -685.0712890625,
        -2168.956298828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -770.8285522460938,
        -2408.3671875,
        1051.602294921875
      ],
      "bbox_max": [
        -685.0712890625,
        -2309.6298828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -767.986572265625,
        -2361.8173828125,
        1420.5723876953125
      ],
      "bbox_max": [
        -752.145263671875,
        -2317.737060546875,
        1442.964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        1051.602294921875
      ],
      "bbox_max": [
        -685.0712890625,
        -2312.703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2370.765380859375,
        1342.03466796875
      ],
      "bbox_max": [
        -741.3680419921875,
        -2317.737060546875,
        1443.3846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -767.986572265625,
        -2370.765380859375,
        1420.5723876953125
      ],
      "bbox_max": [
        -741.3680419921875,
        -2317.737060546875,
        1443.3846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2356.54345703125,
        686.6377563476562
      ],
      "bbox_max": [
        -724.2152099609375,
        -2168.956298828125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -860.804443359375,
        -2356.54345703125,
        686.6377563476562
      ],
      "bbox_max": [
        -724.2152099609375,
        -2173.491455078125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.5051879882812,
        -2356.54345703125,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2152099609375,
        -2299.141845703125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -761.962646484375,
        -2356.54345703125,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2152099609375,
        -2312.703125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -748.221923828125,
        -2356.54345703125,
        1345.988037109375
      ],
      "bbox_max": [
        -724.2152099609375,
        -2333.05322265625,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -748.221923828125,
        -2334.37548828125,
        1420.5723876953125
      ],
      "bbox_max": [
        -746.9424438476562,
        -2333.05322265625,
        1420.805419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -860.804443359375,
        -2316.721435546875,
        686.6377563476562
      ],
      "bbox_max": [
        -752.123779296875,
        -2173.491455078125,
        1403.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -860.804443359375,
        -2312.703125,
        1003.4501953125
      ],
      "bbox_max": [
        -761.962646484375,
        -2173.491455078125,
        1402.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -860.804443359375,
        -2224.935791015625,
        1063.431396484375
      ],
      "bbox_max": [
        -819.005859375,
        -2173.491455078125,
        1266.926025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.74169921875,
        -2312.703125,
        1003.4501953125
      ],
      "bbox_max": [
        -761.962646484375,
        -2280.03857421875,
        1270.7828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.9254150390625,
        -2312.703125,
        1051.602294921875
      ],
      "bbox_max": [
        -761.962646484375,
        -2297.943115234375,
        1403.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -834.5751342773438,
        -2407.66796875,
        787.6181030273438
      ],
      "bbox_max": [
        -685.0712890625,
        -2190.7646484375,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -834.5751342773438,
        -2286.75732421875,
        787.6181030273438
      ],
      "bbox_max": [
        -765.1950073242188,
        -2190.7646484375,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -834.5751342773438,
        -2286.75732421875,
        787.6181030273438
      ],
      "bbox_max": [
        -765.1950073242188,
        -2190.7646484375,
        1063.431396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -775.6288452148438,
        -2286.75732421875,
        833.0492553710938
      ],
      "bbox_max": [
        -765.1950073242188,
        -2264.033447265625,
        1003.4501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -786.48876953125,
        -2407.66796875,
        930.5117797851562
      ],
      "bbox_max": [
        -685.0712890625,
        -2264.956787109375,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -786.48876953125,
        -2407.66796875,
        930.5117797851562
      ],
      "bbox_max": [
        -685.0712890625,
        -2264.956787109375,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -742.3386840820312,
        -2407.66796875,
        1126.5184326171875
      ],
      "bbox_max": [
        -685.0712890625,
        -2326.515869140625,
        1376.480224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -742.3386840820312,
        -2338.6396484375,
        1126.5184326171875
      ],
      "bbox_max": [
        -733.4498291015625,
        -2326.515869140625,
        1376.480224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -742.3386840820312,
        -2332.29296875,
        1126.5184326171875
      ],
      "bbox_max": [
        -733.7015380859375,
        -2326.515869140625,
        1229.13818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -786.48876953125,
        -2280.03857421875,
        1270.7828369140625
      ],
      "bbox_max": [
        -778.74169921875,
        -2264.956787109375,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -779.9501342773438,
        -2407.66796875,
        1019.874267578125
      ],
      "bbox_max": [
        -685.0712890625,
        -2259.135009765625,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510375976562,
        -2333.14013671875,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1166381835938,
        -2332.1337890625,
        1178.760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510375976562,
        -2332.5322265625,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1773681640625,
        -2332.1337890625,
        1165.0404052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -781.3290405273438,
        -2264.304931640625,
        942.7565307617188
      ],
      "bbox_max": [
        -774.9893798828125,
        -2254.945068359375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -781.3290405273438,
        -2257.5849609375,
        946.2813720703125
      ],
      "bbox_max": [
        -779.5615234375,
        -2254.945068359375,
        969.53857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.7763061523438,
        -2356.0107421875,
        948.3525390625
      ],
      "bbox_max": [
        -718.0658569335938,
        -2256.816650390625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2263.15966796875,
        948.3525390625
      ],
      "bbox_max": [
        -775.4889526367188,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -779.7763061523438,
        -2263.15966796875,
        948.3525390625
      ],
      "bbox_max": [
        -775.4889526367188,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1154.5731201171875
      ],
      "bbox_max": [
        -732.9428100585938,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.188232421875,
        -2332.605712890625,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1160.839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -498.223876953125,
        -2820.1337890625,
        529.9791259765625
      ],
      "bbox_max": [
        -482.3701171875,
        -2800.61376953125,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -498.223876953125,
        -2808.2001953125,
        1385.04638671875
      ],
      "bbox_max": [
        -495.4368591308594,
        -2806.955322265625,
        1388.3187255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -495.48614501953125,
        -3919.642822265625,
        529.9791259765625
      ],
      "bbox_max": [
        569.706298828125,
        -1739.924072265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -495.48614501953125,
        -3796.41357421875,
        529.9791259765625
      ],
      "bbox_max": [
        330.92059326171875,
        -2800.61376953125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -495.48614501953125,
        -3796.41357421875,
        651.6136474609375
      ],
      "bbox_max": [
        330.92059326171875,
        -2807.683837890625,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -495.48614501953125,
        -3796.41357421875,
        651.6136474609375
      ],
      "bbox_max": [
        330.92059326171875,
        -2807.910400390625,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -306.5951843261719,
        -3796.41357421875,
        699.01806640625
      ],
      "bbox_max": [
        330.92059326171875,
        -2982.99560546875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -306.4415588378906,
        -3796.41357421875,
        1354.7957763671875
      ],
      "bbox_max": [
        330.92059326171875,
        -2983.1630859375,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -306.4415588378906,
        -3792.079345703125,
        1354.7957763671875
      ],
      "bbox_max": [
        325.8473815917969,
        -2983.1630859375,
        1752.8780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -306.4415588378906,
        -3792.079345703125,
        1354.7957763671875
      ],
      "bbox_max": [
        325.8473815917969,
        -2983.1630859375,
        1752.8780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        211.637451171875,
        -3792.079345703125,
        1517.2542724609375
      ],
      "bbox_max": [
        325.8473815917969,
        -3760.123046875,
        1752.8780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        236.71875,
        -3781.34228515625,
        1517.2542724609375
      ],
      "bbox_max": [
        325.8473815917969,
        -3760.123046875,
        1622.210693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -306.4415588378906,
        -3171.47509765625,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.4415588378906,
        -3031.18994140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        303.9524230957031,
        -3796.41357421875,
        1518.7515869140625
      ],
      "bbox_max": [
        330.92059326171875,
        -3775.821533203125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        315.1397705078125,
        -3784.984130859375,
        1518.7515869140625
      ],
      "bbox_max": [
        328.59930419921875,
        -3775.821533203125,
        1640.2244873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        699.01806640625
      ],
      "bbox_max": [
        -229.613525390625,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -230.98654174804688,
        -3015.99462890625,
        699.01806640625
      ],
      "bbox_max": [
        -229.613525390625,
        -3014.861328125,
        707.4091186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -495.48614501953125,
        -3024.712158203125,
        651.6136474609375
      ],
      "bbox_max": [
        -230.64047241210938,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -495.48614501953125,
        -2981.805908203125,
        688.5384521484375
      ],
      "bbox_max": [
        -307.68572998046875,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -495.48614501953125,
        -2965.37353515625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.7486572265625,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -495.4368591308594,
        -2965.37353515625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.7486572265625,
        -2808.2001953125,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -495.4368591308594,
        -2860.219482421875,
        1388.3187255859375
      ],
      "bbox_max": [
        -378.988037109375,
        -2808.2001953125,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.8818359375,
        -2965.37353515625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.7486572265625,
        -2854.516357421875,
        1425.1151123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -347.90234375,
        -2965.37353515625,
        1313.6531982421875
      ],
      "bbox_max": [
        -322.7486572265625,
        -2932.19970703125,
        1425.1151123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -347.90234375,
        -2965.37353515625,
        1402.2528076171875
      ],
      "bbox_max": [
        -322.7486572265625,
        -2937.93310546875,
        1425.1151123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -331.759765625,
        -2981.805908203125,
        688.5384521484375
      ],
      "bbox_max": [
        -307.68572998046875,
        -2924.27294921875,
        1430.8128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -331.759765625,
        -2981.805908203125,
        1313.6531982421875
      ],
      "bbox_max": [
        -307.68572998046875,
        -2932.19970703125,
        1430.8128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -325.2165222167969,
        -2981.805908203125,
        1395.33251953125
      ],
      "bbox_max": [
        -307.68572998046875,
        -2956.982421875,
        1430.8128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -331.759765625,
        -2943.16455078125,
        1249.12158203125
      ],
      "bbox_max": [
        -321.032958984375,
        -2932.19970703125,
        1321.677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -331.759765625,
        -2943.16455078125,
        1313.6531982421875
      ],
      "bbox_max": [
        -322.1067199707031,
        -2932.19970703125,
        1321.677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -322.5382995605469,
        -3024.712158203125,
        688.5384521484375
      ],
      "bbox_max": [
        -230.64047241210938,
        -2924.27294921875,
        1431.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -313.4547119140625,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2966.85888671875,
        1431.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -321.032958984375,
        -3014.8681640625,
        688.5384521484375
      ],
      "bbox_max": [
        -230.64047241210938,
        -2924.27294921875,
        1249.1214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0024721375666558743,
        0.9531360864639282,
        0.3025318682193756
      ],
      "plane_d": 1821.989013671875,
      "bbox_min": [
        -484.5012512207031,
        -3919.642822265625,
        892.0
      ],
      "bbox_max": [
        569.706298828125,
        -1739.924072265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42004507780075073,
        0.4338691234588623,
        0.7970694899559021
      ],
      "plane_d": 4.887939453125,
      "bbox_min": [
        -239.903076171875,
        -3919.642822265625,
        937.2014770507812
      ],
      "bbox_max": [
        569.706298828125,
        -2217.946533203125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32017049193382263,
        0.5482189655303955,
        0.7726233601570129
      ],
      "plane_d": 300.9718017578125,
      "bbox_min": [
        -239.903076171875,
        -3919.642822265625,
        937.2014770507812
      ],
      "bbox_max": [
        569.706298828125,
        -2217.946533203125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7759400010108948,
        0.4866269528865814,
        0.4013866186141968
      ],
      "plane_d": 605.982421875,
      "bbox_min": [
        -239.903076171875,
        -3919.642822265625,
        937.2014770507812
      ],
      "bbox_max": [
        569.706298828125,
        -2217.946533203125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7798405289649963,
        0.46382713317871094,
        0.42037254571914673
      ],
      "plane_d": 529.9271850585938,
      "bbox_min": [
        -239.903076171875,
        -3919.642822265625,
        937.2014770507812
      ],
      "bbox_max": [
        569.706298828125,
        -2217.946533203125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -144.019287109375,
        -3919.642822265625,
        937.2014770507812
      ],
      "bbox_max": [
        569.706298828125,
        -2217.946533203125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        328.0791320800781,
        -3812.21435546875,
        1518.7890625
      ],
      "bbox_max": [
        435.65338134765625,
        -3776.214599609375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        328.59930419921875,
        -3812.21435546875,
        1640.2244873046875
      ],
      "bbox_max": [
        429.236328125,
        -3784.984130859375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6415850520133972,
        0.763245701789856,
        0.0763196349143982
      ],
      "plane_d": 2498.803955078125,
      "bbox_min": [
        429.236328125,
        -3906.921142578125,
        1520.5963134765625
      ],
      "bbox_max": [
        569.706298828125,
        -3795.162109375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        429.236328125,
        -3812.21435546875,
        1520.5963134765625
      ],
      "bbox_max": [
        440.13232421875,
        -3795.162109375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -484.5012512207031,
        -2303.484619140625,
        892.0
      ],
      "bbox_max": [
        129.7200469970703,
        -1739.924072265625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -484.5012512207031,
        -2303.484619140625,
        892.0
      ],
      "bbox_max": [
        63.3701171875,
        -1739.924072265625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -484.5012512207031,
        -1940.0,
        892.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -442.0,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        895.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1884.4998779296875,
      "bbox_min": [
        -442.0,
        -1919.0,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        893.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -442.0,
        -1919.0,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -442.0,
        -1919.0,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 1919.0,
      "bbox_min": [
        -397.2125244140625,
        -1919.0,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        895.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1928.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1910.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1910.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -397.9250183105469,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1910.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -397.9250183105469,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1919.0,
      "bbox_min": [
        -397.9250183105469,
        -1919.0,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1919.0,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -67.09133911132812,
      "bbox_min": [
        -391.2826232910156,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1886.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        895.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1884.4998779296875,
      "bbox_min": [
        -431.79998779296875,
        -1886.0,
        893.5
      ],
      "bbox_max": [
        -358.20001220703125,
        -1884.5,
        895.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -431.79998779296875,
        -1886.0,
        893.5
      ],
      "bbox_max": [
        -358.20001220703125,
        -1884.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -431.79998779296875,
        -1886.0,
        893.5
      ],
      "bbox_max": [
        -430.0,
        -1884.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        895.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1893.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -440.20001220703125,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -349.79998779296875,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -440.20001220703125,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -420.5,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -386.5,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -370.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 386.5,
      "bbox_min": [
        -386.5,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1886.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 386.5,
      "bbox_min": [
        -386.5,
        -1890.0,
        894.0
      ],
      "bbox_max": [
        -386.5,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1063.84228515625,
      "bbox_min": [
        -388.5,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1890.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 386.5,
      "bbox_min": [
        -386.5,
        -1891.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1890.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1893.0,
        894.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -349.79998779296875,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -442.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -442.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -440.5,
        -1893.25,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -440.5,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -440.5,
        -1893.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -440.5,
        -1893.25,
        893.5
      ],
      "bbox_max": [
        -440.20001220703125,
        -1893.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1887.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        894.5
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        -433.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -357.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -370.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -357.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -370.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -433.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        894.5
      ],
      "bbox_max": [
        -348.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        894.5
      ],
      "bbox_max": [
        -348.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        894.5
      ],
      "bbox_max": [
        -348.0,
        -1887.0,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -357.0,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -348.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -442.0,
        -1910.0,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -442.0,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -440.5,
        -1893.25,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -440.5,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1888.0,
      "bbox_min": [
        -421.0,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        -420.5,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -420.5,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -420.5,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -421.0,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -420.5,
        -1888.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -421.0,
        -1894.5,
        894.5
      ],
      "bbox_max": [
        -420.5,
        -1893.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.991968035697937,
        -0.024799127131700516,
        0.12403471022844315
      ],
      "plane_d": 308.7403564453125,
      "bbox_min": [
        -484.5012512207031,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.987808108329773,
        -0.09407690167427063,
        0.12403467297554016
      ],
      "plane_d": 176.9586639404297,
      "bbox_min": [
        -484.5012512207031,
        -1922.61865234375,
        895.0
      ],
      "bbox_max": [
        -470.0,
        -1873.4002685546875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4837842583656311,
        0.8675420880317688,
        0.11542757600545883
      ],
      "plane_d": 1788.2166748046875,
      "bbox_min": [
        -484.5012512207031,
        -1922.61865234375,
        895.0
      ],
      "bbox_max": [
        -471.0864562988281,
        -1916.0,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44328683614730835,
        0.8865736722946167,
        0.13222679495811462
      ],
      "plane_d": 1790.4500732421875,
      "bbox_min": [
        -474.0,
        -1918.0701904296875,
        895.0
      ],
      "bbox_max": [
        -471.0864562988281,
        -1916.0,
        902.1705932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9610140919685364,
        -0.24711816012859344,
        0.12403468042612076
      ],
      "plane_d": -877.0769653320312,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36369356513023376,
        -0.9232238531112671,
        0.12403438985347748
      ],
      "plane_d": -1887.0693359375,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27259883284568787,
        -0.954099178314209,
        0.12403497099876404
      ],
      "plane_d": -1706.5380859375,
      "bbox_min": [
        -370.0,
        -1778.0,
        895.0
      ],
      "bbox_max": [
        -334.8726501464844,
        -1757.5634765625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 361.5999450683594,
      "bbox_min": [
        -369.8363342285156,
        -1777.00439453125,
        915.8659057617188
      ],
      "bbox_max": [
        -361.5999755859375,
        -1770.659912109375,
        933.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.579657914087875e-06,
        -0.9383420348167419,
        -0.34570831060409546
      ],
      "plane_d": -1346.9508056640625,
      "bbox_min": [
        -369.8363342285156,
        -1777.00439453125,
        915.8659057617188
      ],
      "bbox_max": [
        -361.5999755859375,
        -1770.659912109375,
        933.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -933.0,
      "bbox_min": [
        -369.7569274902344,
        -1776.2037353515625,
        933.0
      ],
      "bbox_max": [
        -361.5999755859375,
        -1770.659912109375,
        933.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9085974097251892,
        0.4001162648200989,
        0.11982358247041702
      ],
      "plane_d": 334.5862731933594,
      "bbox_min": [
        -357.67523193359375,
        -1928.0,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1840.0,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -357.67523193359375,
        -1928.0,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        926.5128784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -357.67523193359375,
        -1928.0,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1900.24951171875,
        926.5128784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7892892360687256,
        -0.6013632416725159,
        0.12403453886508942
      ],
      "plane_d": -820.4692993164062,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -340.5835266113281,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -340.5835266113281,
        -1769.9007568359375,
        975.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9585986137390137,
        0.2788650393486023,
        0.057644907385110855
      ],
      "plane_d": 54.690216064453125,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        -442.0,
        -1931.5,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -442.0,
        -1931.5,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -436.0,
        -1928.0,
        921.0
      ],
      "bbox_max": [
        -354.0,
        -1898.1395263671875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -436.0,
        -1928.0,
        921.0
      ],
      "bbox_max": [
        -430.0,
        -1903.3736572265625,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -442.0,
        -1931.5,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        921.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1928.0,
      "bbox_min": [
        -442.0,
        -1931.5,
        895.0
      ],
      "bbox_max": [
        -351.3995361328125,
        -1910.0,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1931.5,
      "bbox_min": [
        -412.5,
        -1931.5,
        900.5
      ],
      "bbox_max": [
        -396.5,
        -1931.5,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1928.0,
        895.0
      ],
      "bbox_max": [
        -351.3995361328125,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -354.0,
        -1917.4586181640625,
        917.0993041992188
      ],
      "bbox_max": [
        -351.3995361328125,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -398.4000244140625,
        -1928.0,
        895.0
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1919.0,
      "bbox_min": [
        -398.4000244140625,
        -1919.0,
        895.0
      ],
      "bbox_max": [
        -395.0,
        -1913.5,
        904.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 902.0,
      "bbox_min": [
        -396.5,
        -1919.0,
        902.0
      ],
      "bbox_max": [
        -395.0,
        -1913.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -392.0,
        -1911.0,
        895.0
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1911.0,
        895.0
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 764.1976318359375,
      "bbox_min": [
        -392.0,
        -1911.0,
        895.0
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -67.09133911132812,
      "bbox_min": [
        -392.0,
        -1911.0,
        895.0
      ],
      "bbox_max": [
        -391.2826232910156,
        -1910.0,
        896.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -384.5,
      "bbox_min": [
        -384.5,
        -1911.0,
        896.375
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -383.0,
      "bbox_min": [
        -384.5,
        -1911.0,
        896.375
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 77.09432983398438,
      "bbox_min": [
        -384.5,
        -1911.0,
        900.75
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -442.0,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1906.5,
      "bbox_min": [
        -437.6666564941406,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1897.719970703125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -437.6666564941406,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -437.6666564941406,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -436.0,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -396.0,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9983712434768677,
        -0.05704978480935097
      ],
      "plane_d": 1957.4351806640625,
      "bbox_min": [
        -396.0,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -365.0,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -247.41665649414062,
      "bbox_min": [
        -396.0,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -365.0,
        -1908.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -365.0,
        -1908.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 396.0,
      "bbox_min": [
        -396.0,
        -1909.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1908.1142578125,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -396.0,
        -1908.142822265625,
        918.5
      ],
      "bbox_max": [
        -365.0,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 396.0,
      "bbox_min": [
        -396.0,
        -1908.142822265625,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1906.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -437.6666564941406,
        -1906.5,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1897.719970703125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -437.6666564941406,
        -1906.5,
        918.5
      ],
      "bbox_max": [
        -365.0,
        -1898.528564453125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -437.6666564941406,
        -1906.5,
        918.5
      ],
      "bbox_max": [
        -430.0,
        -1902.85205078125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -437.6666564941406,
        -1906.5,
        918.5
      ],
      "bbox_max": [
        -436.0,
        -1903.1668701171875,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -442.0,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 903.5,
      "bbox_min": [
        -379.0,
        -1910.0,
        903.5
      ],
      "bbox_max": [
        -371.0,
        -1909.0,
        903.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -442.0,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -432.734375,
        -1900.4041748046875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -442.0,
        -1910.0,
        912.0
      ],
      "bbox_max": [
        -437.6666564941406,
        -1902.68212890625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -440.5,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -440.5,
        -1900.4041748046875,
        911.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9266379475593567,
        0.37453675270080566,
        0.03262589871883392
      ],
      "plane_d": 275.91961669921875,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -440.0683898925781,
        -1900.4998779296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44328683614730835,
        0.8865736722946167,
        0.13222679495811462
      ],
      "plane_d": 1790.4500732421875,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -441.5740966796875,
        -1900.4998779296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4837842583656311,
        0.8675420880317688,
        0.11542757600545883
      ],
      "plane_d": 1788.2166748046875,
      "bbox_min": [
        -481.2185974121094,
        -1939.09716796875,
        895.0
      ],
      "bbox_max": [
        -441.5740966796875,
        -1900.4998779296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1904.0140380859375,
        895.0
      ],
      "bbox_max": [
        -441.5740966796875,
        -1900.4998779296875,
        912.6388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -442.0,
        -1904.0140380859375,
        912.0
      ],
      "bbox_max": [
        -441.5740966796875,
        -1902.6292724609375,
        912.6388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8741573691368103,
        0.4856429696083069
      ],
      "plane_d": 1204.4432373046875,
      "bbox_min": [
        -442.0,
        -1904.117919921875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1769.9007568359375,
        953.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        -442.0,
        -1904.117919921875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1875.0555419921875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -442.0,
        -1904.117919921875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1875.0555419921875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -436.0,
        -1904.117919921875,
        921.0
      ],
      "bbox_max": [
        -354.0,
        -1889.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5888015031814575,
        0.706561803817749,
        0.3925343155860901
      ],
      "plane_d": 720.3397216796875,
      "bbox_min": [
        -436.0,
        -1899.6497802734375,
        921.0
      ],
      "bbox_max": [
        -354.0,
        -1889.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -360.0,
        -1899.6497802734375,
        921.0
      ],
      "bbox_max": [
        -354.0,
        -1894.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1884.5,
      "bbox_min": [
        -442.0,
        -1903.37353515625,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1875.0555419921875,
        921.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.5888015031814575,
        0.706561803817749,
        0.3925343155860901
      ],
      "plane_d": 720.3397216796875,
      "bbox_min": [
        -436.35552978515625,
        -1895.0,
        909.8001098632812
      ],
      "bbox_max": [
        -353.64447021484375,
        -1884.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -436.35552978515625,
        -1895.0,
        909.8001098632812
      ],
      "bbox_max": [
        -353.64447021484375,
        -1884.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -436.35552978515625,
        -1895.0,
        909.8001098632812
      ],
      "bbox_max": [
        -353.64447021484375,
        -1884.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -436.35552978515625,
        -1895.0,
        920.4666748046875
      ],
      "bbox_max": [
        -353.64447021484375,
        -1894.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -436.35552978515625,
        -1895.0,
        920.4666748046875
      ],
      "bbox_max": [
        -436.0,
        -1894.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1886.0,
      "bbox_min": [
        -442.0,
        -1903.37353515625,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1884.5,
        921.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1885.0,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        906.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1884.5,
        911.400146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        906.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        910.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        906.0
      ],
      "bbox_max": [
        -430.0,
        -1884.5,
        910.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        906.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1885.0,
        911.400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        906.0
      ],
      "bbox_max": [
        -430.6000061035156,
        -1885.0,
        911.400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1885.0,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1884.5,
        906.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -899.0,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -379.4545593261719,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -380.0,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -379.4545593261719,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -430.6000061035156,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 418.5,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -469.29998779296875,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 974.7000122070312,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -953.5,
      "bbox_min": [
        -390.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 490.5,
      "bbox_min": [
        -390.5,
        -1885.0,
        904.5
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -371.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -359.3999938964844,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -899.0,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -431.79998779296875,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -358.20001220703125,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -431.79998779296875,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -370.0,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -380.0,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -370.0,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -380.0,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -431.8000183105469,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 418.5,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -469.29998779296875,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 974.7000122070312,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -953.5,
      "bbox_min": [
        -390.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 490.5,
      "bbox_min": [
        -390.5,
        -1886.0,
        904.5
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -371.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -358.1999816894531,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -371.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -370.5454406738281,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -442.0,
        -1903.37353515625,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1896.0,
      "bbox_min": [
        -437.6666564941406,
        -1903.37353515625,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -437.6666564941406,
        -1903.37353515625,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -437.6666564941406,
        -1903.37353515625,
        918.5
      ],
      "bbox_max": [
        -436.0,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -396.0,
        -1898.8416748046875,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -354.0,
        -1898.1395263671875,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 396.0,
      "bbox_min": [
        -396.0,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1896.0,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -410.09674072265625,
      "bbox_min": [
        -437.6666564941406,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5888015031814575,
        0.706561803817749,
        0.3925343155860901
      ],
      "plane_d": 720.3397216796875,
      "bbox_min": [
        -437.6666564941406,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -435.4541320800781,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -437.6666564941406,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -436.0,
        -1894.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.734375,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -364.9999694824219,
      "bbox_min": [
        -365.0,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1892.65625,
        921.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5888015031814575,
        0.7065618634223938,
        0.3925343453884125
      ],
      "plane_d": 1185.4930419921875,
      "bbox_min": [
        -354.5458679199219,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -354.0,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -352.3333435058594,
        -1894.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401843428611755,
        0.7682213187217712,
        0.0
      ],
      "plane_d": 1172.433837890625,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -442.0,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1887.0,
      "bbox_min": [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -898.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -420.5,
        -1887.0,
        898.4998779296875
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1888.5,
      "bbox_min": [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -420.5,
        -1888.5,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -420.5,
        -1888.5,
        895.0
      ],
      "bbox_max": [
        -390.5,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -390.5,
        -1888.5,
        897.5
      ],
      "bbox_max": [
        -390.5,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1888.5,
        897.9998779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1894.6202392578125,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        895.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1888.5,
        897.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -440.5,
        -1897.499755859375,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1893.5,
        896.3331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -421.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1893.5,
        896.3331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1886.0,
        918.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.5888015031814575,
        0.706561803817749,
        0.3925343155860901
      ],
      "plane_d": 720.3397216796875,
      "bbox_min": [
        -442.0,
        -1899.2276611328125,
        912.0
      ],
      "bbox_max": [
        -432.4748840332031,
        -1886.5623779296875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -442.0,
        -1899.2276611328125,
        912.0
      ],
      "bbox_max": [
        -437.6666564941406,
        -1894.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1152.11767578125,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -873.6527709960938,
      "bbox_min": [
        -442.0,
        -1903.166748046875,
        912.0
      ],
      "bbox_max": [
        -437.6666564941406,
        -1896.8482666015625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -440.5,
        -1902.4583740234375,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        911.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -421.3089599609375,
        -1894.5,
        895.9998168945312
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -29.51611328125,
      "bbox_min": [
        -421.3089599609375,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000162839889526,
        -0.4000081419944763,
        0.44717705249786377
      ],
      "plane_d": -826.59814453125,
      "bbox_min": [
        -421.3089599609375,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -898.7658081054688,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 401.0,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 411.0,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -415.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -415.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5999755859375,
      "bbox_min": [
        -412.5999755859375,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -412.5999755859375,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5999755859375,
      "bbox_min": [
        -412.5999755859375,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -412.5999755859375,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -415.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -405.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -405.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -405.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 402.5999755859375,
      "bbox_min": [
        -402.5999755859375,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -402.5999755859375,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 402.5999755859375,
      "bbox_min": [
        -402.5999755859375,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -402.5999755859375,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -405.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -395.0,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -395.0,
      "bbox_min": [
        -395.0,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -395.0,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -395.0,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -392.0,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -392.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -395.0,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1888.0946044921875,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -365.0,
        -1875.5,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1875.0555419921875,
        895.7810668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 349.87347412109375,
      "bbox_min": [
        -365.0,
        -1875.5,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1875.0555419921875,
        895.7810668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -377.0601501464844,
      "bbox_min": [
        -365.0,
        -1875.5,
        895.0
      ],
      "bbox_max": [
        -364.98944091796875,
        -1875.0555419921875,
        895.7810668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929733157157898,
        -0.15639756619930267,
        -0.3333706557750702
      ],
      "plane_d": 398.11651611328125,
      "bbox_min": [
        -441.44793701171875,
        -1884.9921875,
        895.0
      ],
      "bbox_max": [
        -361.5999755859375,
        -1769.9007568359375,
        953.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01175545621663332,
        -0.9187977910041809,
        0.3945533037185669
      ],
      "plane_d": -2068.292724609375,
      "bbox_min": [
        -441.44793701171875,
        -1880.676025390625,
        895.0
      ],
      "bbox_max": [
        -395.3102111816406,
        -1814.8470458984375,
        953.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9011631011962891,
        0.17953407764434814,
        0.39455363154411316
      ],
      "plane_d": -402.6596984863281,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -395.3102111816406,
        -1814.8470458984375,
        953.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04032636806368828,
        0.9419329762458801,
        -0.33337053656578064
      ],
      "plane_d": 2063.74755859375,
      "bbox_min": [
        -422.1572570800781,
        -1857.9818115234375,
        895.0
      ],
      "bbox_max": [
        -395.3102111816406,
        -1814.8470458984375,
        953.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -421.6086120605469,
        -1857.9818115234375,
        903.0
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.497726172208786,
        -0.4529552161693573,
        -0.739662230014801
      ],
      "plane_d": -371.5120849609375,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.546542227268219,
        -0.3926725387573242,
        -0.7396619915962219
      ],
      "plane_d": -280.09307861328125,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5407828092575073,
        -0.1870790719985962,
        -0.820094645023346
      ],
      "plane_d": 176.46441650390625,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2954280376434326,
        -0.49007007479667664,
        -0.8200936317443848
      ],
      "plane_d": -283.0264892578125,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -416.3827209472656,
        -1854.2542724609375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2380163073539734,
        -0.24262867867946625,
        -0.9404677152633667
      ],
      "plane_d": 308.8880615234375,
      "bbox_min": [
        -416.3827209472656,
        -1854.124755859375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -416.3827209472656,
        -1854.124755859375,
        910.5301513671875
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -416.3827209472656,
        -1854.124755859375,
        910.8003540039062
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4328785538673401,
        -0.4926200807094574,
        -0.7549447417259216
      ],
      "plane_d": -404.15673828125,
      "bbox_min": [
        -416.3827209472656,
        -1854.07470703125,
        910.8003540039062
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -416.3827209472656,
        -1854.07470703125,
        910.8003540039062
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3516869843006134,
        0.1426827609539032,
        0.9251800179481506
      ],
      "plane_d": -433.4312438964844,
      "bbox_min": [
        -416.376220703125,
        -1854.07470703125,
        910.8003540039062
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5698388814926147,
        -0.24880445003509521,
        -0.7831858992576599
      ],
      "plane_d": 16.4239501953125,
      "bbox_min": [
        -416.376220703125,
        -1853.3485107421875,
        910.8003540039062
      ],
      "bbox_max": [
        -413.16387939453125,
        -1850.6495361328125,
        912.3033447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -415.3869323730469,
        -1853.3485107421875,
        910.8003540039062
      ],
      "bbox_max": [
        -413.16387939453125,
        -1850.6495361328125,
        911.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -414.92291259765625,
        -1853.3485107421875,
        910.8003540039062
      ],
      "bbox_max": [
        -413.16387939453125,
        -1850.778564453125,
        911.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21471019089221954,
        -0.3865227997303009,
        -0.8969390392303467
      ],
      "plane_d": 12.32232666015625,
      "bbox_min": [
        -414.92291259765625,
        -1853.3485107421875,
        910.8003540039062
      ],
      "bbox_max": [
        -413.16387939453125,
        -1852.00927734375,
        911.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2126915007829666,
        -0.31433331966400146,
        -0.9251794219017029
      ],
      "plane_d": 172.6290283203125,
      "bbox_min": [
        -414.92291259765625,
        -1852.688232421875,
        910.8003540039062
      ],
      "bbox_max": [
        -413.16387939453125,
        -1852.00927734375,
        911.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24374565482139587,
        0.4482356011867523,
        0.8600425124168396
      ],
      "plane_d": 147.18524169921875,
      "bbox_min": [
        -416.1677551269531,
        -1854.07470703125,
        910.96728515625
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29542335867881775,
        0.49008437991142273,
        0.8200867772102356
      ],
      "plane_d": 282.5673828125,
      "bbox_min": [
        -416.1677551269531,
        -1854.07470703125,
        910.96728515625
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23800967633724213,
        0.24263064563274384,
        0.9404689073562622
      ],
      "plane_d": -309.378173828125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        910.96728515625
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2868129014968872,
        0.18236376345157623,
        0.940468966960907
      ],
      "plane_d": -400.7735595703125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        910.96728515625
      ],
      "bbox_max": [
        -412.914306640625,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4977271854877472,
        0.45295774936676025,
        0.7396600246429443
      ],
      "plane_d": 371.02935791015625,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.2348022460938
      ],
      "bbox_max": [
        -412.981689453125,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4891250431537628,
        0.1452295333147049,
        0.8600378036499023
      ],
      "plane_d": -312.31817626953125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.2348022460938
      ],
      "bbox_max": [
        -412.981689453125,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5465455055236816,
        0.39267194271087646,
        0.7396597862243652
      ],
      "plane_d": 279.60552978515625,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.2348022460938
      ],
      "bbox_max": [
        -412.981689453125,
        -1850.3052978515625,
        913.46533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5407907962799072,
        0.18706630170345306,
        0.8200924396514893
      ],
      "plane_d": -176.97271728515625,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.2348022460938
      ],
      "bbox_max": [
        -412.981689453125,
        -1850.3052978515625,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21268339455127716,
        0.3143380582332611,
        0.9251796007156372
      ],
      "plane_d": -173.11376953125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.2348022460938
      ],
      "bbox_max": [
        -412.981689453125,
        -1850.5064697265625,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21470198035240173,
        0.3865348994731903,
        0.8969358205795288
      ],
      "plane_d": -12.790283203125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.4697265625
      ],
      "bbox_max": [
        -413.010498046875,
        -1850.5064697265625,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4227268099784851,
        0.12964682281017303,
        0.8969358801841736
      ],
      "plane_d": -402.36334228515625,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.4697265625
      ],
      "bbox_max": [
        -413.96734619140625,
        -1850.5064697265625,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36181771755218506,
        0.5056677460670471,
        0.7831909656524658
      ],
      "plane_d": 372.61016845703125,
      "bbox_min": [
        -416.1677551269531,
        -1853.9462890625,
        911.8028564453125
      ],
      "bbox_max": [
        -413.96734619140625,
        -1851.274658203125,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.432862788438797,
        0.49263185262680054,
        0.7549461126327515
      ],
      "plane_d": 403.68096923828125,
      "bbox_min": [
        -416.1677551269531,
        -1853.8365478515625,
        911.8028564453125
      ],
      "bbox_max": [
        -414.6307678222656,
        -1851.274658203125,
        913.0053100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5698422789573669,
        0.2487795054912567,
        0.7831912636756897
      ],
      "plane_d": -16.96356201171875,
      "bbox_min": [
        -416.1677551269531,
        -1852.6002197265625,
        911.8028564453125
      ],
      "bbox_max": [
        -414.7229309082031,
        -1851.274658203125,
        913.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718623995780945,
        0.32098817825317383,
        0.7549437284469604
      ],
      "plane_d": 143.3858642578125,
      "bbox_min": [
        -416.1677551269531,
        -1852.6002197265625,
        911.8028564453125
      ],
      "bbox_max": [
        -414.7229309082031,
        -1851.9464111328125,
        913.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -903.0,
      "bbox_min": [
        -421.6086120605469,
        -1857.9818115234375,
        903.0
      ],
      "bbox_max": [
        -413.6419982910156,
        -1851.4642333984375,
        909.2294921875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.6661451458930969,
        0.5394249558448792,
        -0.5150449872016907
      ],
      "plane_d": 1742.586669921875,
      "bbox_min": [
        -419.9919738769531,
        -1857.338623046875,
        904.0018310546875
      ],
      "bbox_max": [
        -413.6419982910156,
        -1851.4642333984375,
        909.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4002443253993988,
        -0.3241121768951416,
        -0.8571790456771851
      ],
      "plane_d": 6.7198486328125,
      "bbox_min": [
        -419.9919738769531,
        -1857.338623046875,
        904.0018310546875
      ],
      "bbox_max": [
        -415.4844055175781,
        -1852.864013671875,
        907.431396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -419.9919738769531,
        -1856.9820556640625,
        904.0018310546875
      ],
      "bbox_max": [
        -415.4844055175781,
        -1852.8887939453125,
        907.431396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -419.9919738769531,
        -1856.9820556640625,
        905.2894287109375
      ],
      "bbox_max": [
        -418.25653076171875,
        -1854.8389892578125,
        907.431396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21578966081142426,
        0.22774909436702728,
        -0.9495078325271606
      ],
      "plane_d": 1190.307373046875,
      "bbox_min": [
        -422.1572570800781,
        -1853.5599365234375,
        895.0
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.8470458984375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -419.37286376953125,
        -1853.0655517578125,
        904.161865234375
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.8470458984375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4170345366001129,
        0.26467418670654297,
        -0.8694997429847717
      ],
      "plane_d": 1102.293212890625,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        907.197509765625
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.8470458984375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4169886112213135,
        -0.2651565372943878,
        0.8693748116493225
      ],
      "plane_d": -1103.5703125,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        907.197509765625
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.8470458984375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -413.0338134765625,
        -1834.7105712890625,
        907.197509765625
      ],
      "bbox_max": [
        -406.95672607421875,
        -1814.8470458984375,
        912.0382080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3901956379413605,
        0.9139581918716431,
        0.1114799752831459
      ],
      "plane_d": 1716.3851318359375,
      "bbox_min": [
        -408.14068603515625,
        -1815.3348388671875,
        910.6934204101562
      ],
      "bbox_max": [
        -406.95672607421875,
        -1814.8470458984375,
        911.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21560680866241455,
        -0.22821097075939178,
        0.9494384527206421
      ],
      "plane_d": -1191.6541748046875,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        907.2626953125
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.9708251953125,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -413.0338134765625,
        -1835.283935546875,
        907.2626953125
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.9708251953125,
        911.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3901956379413605,
        0.9139581918716431,
        0.1114799752831459
      ],
      "plane_d": 1716.3851318359375,
      "bbox_min": [
        -407.98150634765625,
        -1815.3988037109375,
        910.9059448242188
      ],
      "bbox_max": [
        -406.8780822753906,
        -1814.9708251953125,
        911.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3516869843006134,
        0.1426827609539032,
        0.9251800179481506
      ],
      "plane_d": -433.4312438964844,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        907.43798828125
      ],
      "bbox_max": [
        -411.26666259765625,
        -1833.4896240234375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        907.43798828125
      ],
      "bbox_max": [
        -411.5560607910156,
        -1834.7105712890625,
        911.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -416.269775390625,
        -1851.0286865234375,
        910.0036010742188
      ],
      "bbox_max": [
        -412.8839111328125,
        -1848.0684814453125,
        911.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -414.0691833496094,
        -1851.0286865234375,
        910.0036010742188
      ],
      "bbox_max": [
        -412.8839111328125,
        -1848.6466064453125,
        910.8003540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -414.0414123535156,
        -1846.208251953125,
        909.4096069335938
      ],
      "bbox_max": [
        -412.6366882324219,
        -1844.202392578125,
        909.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4227268099784851,
        0.12964682281017303,
        0.8969358801841736
      ],
      "plane_d": -402.36334228515625,
      "bbox_min": [
        -416.0559387207031,
        -1850.8817138671875,
        908.1339111328125
      ],
      "bbox_max": [
        -412.7045593261719,
        -1833.4896240234375,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4891250431537628,
        0.1452295333147049,
        0.8600378036499023
      ],
      "plane_d": -312.31817626953125,
      "bbox_min": [
        -416.0559387207031,
        -1850.8817138671875,
        910.4461059570312
      ],
      "bbox_max": [
        -412.7045593261719,
        -1847.9520263671875,
        912.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2868129014968872,
        0.18236376345157623,
        0.940468966960907
      ],
      "plane_d": -400.7735595703125,
      "bbox_min": [
        -413.87786865234375,
        -1850.8817138671875,
        910.4461059570312
      ],
      "bbox_max": [
        -412.7045593261719,
        -1848.5238037109375,
        911.2348022460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -419.37286376953125,
        -1853.0655517578125,
        904.161865234375
      ],
      "bbox_max": [
        -412.6866760253906,
        -1843.952880859375,
        910.6805419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -416.7771911621094,
        -1847.0267333984375,
        907.478271484375
      ],
      "bbox_max": [
        -412.6866760253906,
        -1843.952880859375,
        910.6805419921875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6293317079544067,
        0.7771368622779846,
        -1.3346001423997222e-06
      ],
      "plane_d": 1172.32958984375,
      "bbox_min": [
        -416.7771911621094,
        -1846.031982421875,
        907.478271484375
      ],
      "bbox_max": [
        -414.2098083496094,
        -1843.952880859375,
        910.6805419921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6661451458930969,
        0.5394249558448792,
        -0.5150449872016907
      ],
      "plane_d": 1742.586669921875,
      "bbox_min": [
        -419.37286376953125,
        -1853.0655517578125,
        904.161865234375
      ],
      "bbox_max": [
        -413.67352294921875,
        -1848.3751220703125,
        909.7576293945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293251514434814,
        0.7771421670913696,
        8.21054072730476e-06
      ],
      "plane_d": 1174.5333251953125,
      "bbox_min": [
        -419.37286376953125,
        -1853.0655517578125,
        904.161865234375
      ],
      "bbox_max": [
        -415.8336181640625,
        -1848.3751220703125,
        909.7576293945312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -418.2526550292969,
        -1853.0655517578125,
        904.161865234375
      ],
      "bbox_max": [
        -415.8336181640625,
        -1849.9957275390625,
        904.943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -903.0,
      "bbox_min": [
        -422.1572570800781,
        -1853.5599365234375,
        895.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1842.484375,
        905.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5000181198120117,
        0.8660150170326233,
        0.0
      ],
      "plane_d": 1802.876708984375,
      "bbox_min": [
        -414.5,
        -1842.558837890625,
        902.6055297851562
      ],
      "bbox_max": [
        -414.37109375,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -419.936767578125,
        -1853.101806640625,
        903.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1842.484375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4002443253993988,
        -0.3241121768951416,
        -0.8571790456771851
      ],
      "plane_d": 6.7198486328125,
      "bbox_min": [
        -419.936767578125,
        -1853.101806640625,
        904.0018310546875
      ],
      "bbox_max": [
        -418.2526550292969,
        -1850.0574951171875,
        904.9405517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293234825134277,
        0.7771434783935547,
        1.84201926458627e-05
      ],
      "plane_d": 1174.5272216796875,
      "bbox_min": [
        -419.82037353515625,
        -1851.3271484375,
        904.0833740234375
      ],
      "bbox_max": [
        -418.2526550292969,
        -1850.0574951171875,
        904.9405517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370622634887695,
        0.25119492411613464,
        0.24251866340637207
      ],
      "plane_d": -144.58395385742188,
      "bbox_min": [
        -419.92742919921875,
        -1849.483642578125,
        903.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1842.484375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.485092431306839,
        0.8401641845703125,
        0.242506742477417
      ],
      "plane_d": 1530.07666015625,
      "bbox_min": [
        -415.0361328125,
        -1844.6639404296875,
        903.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1842.484375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4850674867630005,
        -0.8401495814323425,
        0.24260728061199188
      ],
      "plane_d": -1970.0377197265625,
      "bbox_min": [
        -415.0361328125,
        -1844.6639404296875,
        903.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1843.2431640625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -414.45361328125,
        -1844.514892578125,
        905.0
      ],
      "bbox_max": [
        -413.8059387207031,
        -1843.2431640625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7276643514633179,
        0.5892499685287476,
        0.351125568151474
      ],
      "plane_d": 1076.8787841796875,
      "bbox_min": [
        -419.92742919921875,
        -1849.483642578125,
        903.0
      ],
      "bbox_max": [
        -418.7412414550781,
        -1847.537109375,
        904.4581298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293194890022278,
        -0.7771466374397278,
        -3.342030083786085e-07
      ],
      "plane_d": -1173.05126953125,
      "bbox_min": [
        -419.92742919921875,
        -1849.483642578125,
        903.0
      ],
      "bbox_max": [
        -418.7412414550781,
        -1848.5230712890625,
        904.4581298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18814587593078613,
        0.9031874537467957,
        0.3858155310153961
      ],
      "plane_d": 1206.4439697265625,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5279554724693298,
        0.4674476087093353,
        0.7090527415275574
      ],
      "plane_d": -36.3538818359375,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40567663311958313,
        0.7271674275398254,
        0.5537635684013367
      ],
      "plane_d": 637.0421142578125,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09119373559951782,
        0.9688279032707214,
        0.2303391546010971
      ],
      "plane_d": 1585.6435546875,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -441.44793701171875,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8337720036506653,
        -0.07279076427221298,
        -0.5472894310951233
      ],
      "plane_d": 10.568115234375,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.3731079101562
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6051303744316101,
        0.2205314040184021,
        -0.7649725675582886
      ],
      "plane_d": 847.20947265625,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.3731079101562
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4170345366001129,
        0.26467418670654297,
        -0.8694997429847717
      ],
      "plane_d": 1102.293212890625,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.3731079101562
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.8680419921875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8394879698753357,
        -0.27731165289878845,
        -0.46728816628456116
      ],
      "plane_d": -443.591064453125,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.3731079101562
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.9915771484375,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4169886112213135,
        -0.2651565372943878,
        0.8693748116493225
      ],
      "plane_d": -1103.5703125,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.3731079101562
      ],
      "bbox_max": [
        -409.09857177734375,
        -1814.9915771484375,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -421.4009094238281,
        -1834.8275146484375,
        908.3731079101562
      ],
      "bbox_max": [
        -414.388427734375,
        -1833.4891357421875,
        912.007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -421.4009094238281,
        -1834.8275146484375,
        910.8653564453125
      ],
      "bbox_max": [
        -419.3368225097656,
        -1833.58642578125,
        912.007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6052127480506897,
        -0.22098834812641144,
        0.7647755742073059
      ],
      "plane_d": -848.3207397460938,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1815.2003173828125,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -426.64044189453125,
        -1837.943115234375,
        910.8987426757812
      ],
      "bbox_max": [
        -419.3368225097656,
        -1834.4395751953125,
        915.7784423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5407828092575073,
        -0.1870790719985962,
        -0.820094645023346
      ],
      "plane_d": 176.46441650390625,
      "bbox_min": [
        -426.64044189453125,
        -1837.943115234375,
        914.4225463867188
      ],
      "bbox_max": [
        -424.7510681152344,
        -1836.404541015625,
        915.7784423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7516751885414124,
        -0.10237963497638702,
        0.6515389680862427
      ],
      "plane_d": -464.62567138671875,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1820.366455078125,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5407828092575073,
        -0.1870790719985962,
        -0.820094645023346
      ],
      "plane_d": 176.46441650390625,
      "bbox_min": [
        -429.864013671875,
        -1843.4764404296875,
        914.4225463867188
      ],
      "bbox_max": [
        -424.7510681152344,
        -1837.4610595703125,
        919.3760375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5698388814926147,
        -0.24880445003509521,
        -0.7831858992576599
      ],
      "plane_d": 16.4239501953125,
      "bbox_min": [
        -429.864013671875,
        -1843.4764404296875,
        917.9464721679688
      ],
      "bbox_max": [
        -428.452392578125,
        -1841.4864501953125,
        919.3760375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8340259194374084,
        0.07254284620285034,
        0.5469353199005127
      ],
      "plane_d": -11.077911376953125,
      "bbox_min": [
        -441.44793701171875,
        -1853.6719970703125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1829.6824951171875,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5698388814926147,
        -0.24880445003509521,
        -0.7831858992576599
      ],
      "plane_d": 16.4239501953125,
      "bbox_min": [
        -441.44793701171875,
        -1849.6959228515625,
        917.9464721679688
      ],
      "bbox_max": [
        -428.452392578125,
        -1841.7305908203125,
        937.2764282226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -441.44793701171875,
        -1849.6959228515625,
        920.9341430664062
      ],
      "bbox_max": [
        -429.8774108886719,
        -1841.7305908203125,
        937.2764282226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364973545074463,
        0.1635679006576538,
        0.8278985619544983
      ],
      "plane_d": -711.151123046875,
      "bbox_min": [
        -441.44793701171875,
        -1843.00146484375,
        936.8031005859375
      ],
      "bbox_max": [
        -441.027099609375,
        -1841.7305908203125,
        937.2764282226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8397529125213623,
        0.2772221565246582,
        0.4668649137020111
      ],
      "plane_d": 443.442626953125,
      "bbox_min": [
        -441.06365966796875,
        -1853.6719970703125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -441.06365966796875,
        -1849.9150390625,
        920.9341430664062
      ],
      "bbox_max": [
        -429.6241149902344,
        -1841.7305908203125,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364973545074463,
        0.1635679006576538,
        0.8278985619544983
      ],
      "plane_d": -711.151123046875,
      "bbox_min": [
        -441.06365966796875,
        -1842.9542236328125,
        937.058349609375
      ],
      "bbox_max": [
        -440.837890625,
        -1841.7305908203125,
        937.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5407907962799072,
        0.18706630170345306,
        0.8200924396514893
      ],
      "plane_d": -176.97271728515625,
      "bbox_min": [
        -430.5671081542969,
        -1853.6719970703125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        922.3975219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5407828092575073,
        -0.1870790719985962,
        -0.820094645023346
      ],
      "plane_d": 176.46441650390625,
      "bbox_min": [
        -429.7685241699219,
        -1853.6719970703125,
        908.62451171875
      ],
      "bbox_max": [
        -415.5633544921875,
        -1835.0286865234375,
        920.7058715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -428.73394775390625,
        -1853.6719970703125,
        910.43408203125
      ],
      "bbox_max": [
        -415.5633544921875,
        -1836.1793212890625,
        920.2031860351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -418.9993591308594,
        -1853.6719970703125,
        910.43408203125
      ],
      "bbox_max": [
        -415.5633544921875,
        -1836.1793212890625,
        914.2761840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.546542227268219,
        -0.3926725387573242,
        -0.7396619915962219
      ],
      "plane_d": -280.09307861328125,
      "bbox_min": [
        -418.4098815917969,
        -1853.6719970703125,
        912.5891723632812
      ],
      "bbox_max": [
        -416.3601379394531,
        -1852.7647705078125,
        914.2761840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293317079544067,
        0.7771368622779846,
        -1.3346001423997222e-06
      ],
      "plane_d": 1172.32958984375,
      "bbox_min": [
        -416.5797424316406,
        -1845.8720703125,
        910.6055297851562
      ],
      "bbox_max": [
        -415.7038879394531,
        -1845.162841796875,
        911.19580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661365628242493,
        -0.5393994450569153,
        0.5150827765464783
      ],
      "plane_d": -1751.37060546875,
      "bbox_min": [
        -422.3187561035156,
        -1852.437255859375,
        915.7903442382812
      ],
      "bbox_max": [
        -420.97357177734375,
        -1850.46923828125,
        916.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293017864227295,
        0.7771610021591187,
        1.581735887157265e-05
      ],
      "plane_d": 1172.3709716796875,
      "bbox_min": [
        -418.33099365234375,
        -1847.2901611328125,
        910.3564453125
      ],
      "bbox_max": [
        -415.7430419921875,
        -1845.194580078125,
        912.431396484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6293244957923889,
        0.7771426439285278,
        2.347829649806954e-06
      ],
      "plane_d": 1172.33984375,
      "bbox_min": [
        -422.4280090332031,
        -1852.56298828125,
        913.8411865234375
      ],
      "bbox_max": [
        -420.0011901855469,
        -1848.6427001953125,
        916.1235961914062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6293286085128784,
        0.7771391868591309,
        -1.1532875760167371e-05
      ],
      "plane_d": 1172.344482421875,
      "bbox_min": [
        -423.42169189453125,
        -1853.2972412109375,
        908.62451171875
      ],
      "bbox_max": [
        -415.8730773925781,
        -1845.2998046875,
        915.8896484375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5698422789573669,
        0.2487795054912567,
        0.7831912636756897
      ],
      "plane_d": -16.96356201171875,
      "bbox_min": [
        -430.5671081542969,
        -1853.4981689453125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        922.3975219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -429.8774108886719,
        -1852.197998046875,
        916.3295288085938
      ],
      "bbox_max": [
        -421.6387939453125,
        -1847.881103515625,
        921.4075927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5698388814926147,
        -0.24880445003509521,
        -0.7831858992576599
      ],
      "plane_d": 16.4239501953125,
      "bbox_min": [
        -429.8774108886719,
        -1848.668212890625,
        920.2031860351562
      ],
      "bbox_max": [
        -428.73394775390625,
        -1847.881103515625,
        920.9341430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4891250431537628,
        0.1452295333147049,
        0.8600378036499023
      ],
      "plane_d": -312.31817626953125,
      "bbox_min": [
        -430.5671081542969,
        -1853.4981689453125,
        908.6200561523438
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        922.3975219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -419.7505187988281,
        -1843.916015625,
        908.6200561523438
      ],
      "bbox_max": [
        -414.5292053222656,
        -1834.7386474609375,
        911.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -419.7505187988281,
        -1836.1793212890625,
        910.8987426757812
      ],
      "bbox_max": [
        -418.9993591308594,
        -1834.8275146484375,
        911.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718623995780945,
        0.32098817825317383,
        0.7549437284469604
      ],
      "plane_d": 143.3858642578125,
      "bbox_min": [
        -430.5671081542969,
        -1853.4981689453125,
        908.83154296875
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        922.3975219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4227268099784851,
        0.12964682281017303,
        0.8969358801841736
      ],
      "plane_d": -402.36334228515625,
      "bbox_min": [
        -419.3992004394531,
        -1853.4981689453125,
        908.83154296875
      ],
      "bbox_max": [
        -414.1932678222656,
        -1833.5169677734375,
        914.6748657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5465455055236816,
        0.39267194271087646,
        0.7396597862243652
      ],
      "plane_d": 279.60552978515625,
      "bbox_min": [
        -418.17401123046875,
        -1853.4981689453125,
        913.0052490234375
      ],
      "bbox_max": [
        -416.1452941894531,
        -1852.6002197265625,
        914.6748657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659989833831787,
        0.500045895576477,
        0.0
      ],
      "plane_d": 553.355224609375,
      "bbox_min": [
        -430.11572265625,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -416.8581237792969,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.11572265625,
      "bbox_min": [
        -430.11572265625,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -416.8581237792969,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000341534614563,
        0.8660057783126831,
        0.0
      ],
      "plane_d": 1385.0377197265625,
      "bbox_min": [
        -430.11572265625,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -416.8581237792969,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -903.0,
      "bbox_min": [
        -430.11572265625,
        -1861.2723388671875,
        895.0
      ],
      "bbox_max": [
        -416.8581237792969,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1842.484375,
      "bbox_min": [
        -421.10009765625,
        -1842.484375,
        897.1367797851562
      ],
      "bbox_max": [
        -418.53302001953125,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293251514434814,
        0.7771421670913696,
        8.21054072730476e-06
      ],
      "plane_d": 1174.5333251953125,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -416.8581237792969,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -421.840087890625,
        -1856.0489501953125,
        904.0018310546875
      ],
      "bbox_max": [
        -417.6201477050781,
        -1851.3271484375,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -421.840087890625,
        -1856.0489501953125,
        904.0018310546875
      ],
      "bbox_max": [
        -419.2951965332031,
        -1851.3271484375,
        907.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -419.9761657714844,
        -1851.54736328125,
        904.0018310546875
      ],
      "bbox_max": [
        -419.82037353515625,
        -1851.3271484375,
        904.0833740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4851042926311493,
        0.8401488661766052,
        0.242535799741745
      ],
      "plane_d": 1124.673828125,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1842.484375,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -636.283203125,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1842.484375,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48506924510002136,
        -0.8401526212692261,
        0.24259306490421295
      ],
      "plane_d": -1564.707275390625,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1842.484375,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -426.8154296875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1842.484375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370363354682922,
        0.2511879801750183,
        0.24262632429599762
      ],
      "plane_d": 638.304443359375,
      "bbox_min": [
        -426.8154296875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1842.484375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6860514283180237,
        -0.6859369874000549,
        0.2425360530614853
      ],
      "plane_d": -1777.919189453125,
      "bbox_min": [
        -426.8154296875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -425.269287109375,
        -1845.784423828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": 196.3236083984375,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -904.9999389648438,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -428.11572265625,
        -1851.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511959671974182,
        0.9370661973953247,
        0.24250248074531555
      ],
      "plane_d": 1624.0416259765625,
      "bbox_min": [
        -430.11572265625,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -428.11572265625,
        -1851.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511908710002899,
        -0.9370471835136414,
        0.2425812929868698
      ],
      "plane_d": -1852.13720703125,
      "bbox_min": [
        -429.09490966796875,
        -1857.826416015625,
        903.0
      ],
      "bbox_max": [
        -428.11572265625,
        -1857.344970703125,
        904.1417236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293244361877441,
        0.7771427035331726,
        -7.511625426559476e-06
      ],
      "plane_d": 1170.548828125,
      "bbox_min": [
        -425.3659973144531,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293194890022278,
        -0.7771466374397278,
        -3.342030083786085e-07
      ],
      "plane_d": -1173.05126953125,
      "bbox_min": [
        -425.3659973144531,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7276657819747925,
        -0.5892511010169983,
        0.3511207103729248
      ],
      "plane_d": -1717.09619140625,
      "bbox_min": [
        -425.3659973144531,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7276643514633179,
        0.5892499685287476,
        0.351125568151474
      ],
      "plane_d": 1076.8787841796875,
      "bbox_min": [
        -424.2002868652344,
        -1851.669677734375,
        903.0
      ],
      "bbox_max": [
        -419.16619873046875,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -907.0,
      "bbox_min": [
        -424.2002868652344,
        -1851.669677734375,
        907.0
      ],
      "bbox_max": [
        -419.906982421875,
        -1847.524169921875,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -421.9276123046875,
        -1852.26904296875,
        905.0
      ],
      "bbox_max": [
        -419.7401428222656,
        -1850.096435546875,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -906.5,
      "bbox_min": [
        -421.9276123046875,
        -1852.26904296875,
        905.0
      ],
      "bbox_max": [
        -419.7401428222656,
        -1850.096435546875,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7771310806274414,
        -0.6293386816978455,
        -0.0
      ],
      "plane_d": -1492.864013671875,
      "bbox_min": [
        -421.9276123046875,
        -1852.26904296875,
        905.0
      ],
      "bbox_max": [
        -419.7401428222656,
        -1850.096435546875,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7771310806274414,
        0.6293386816978455,
        -0.0
      ],
      "plane_d": 1491.263916015625,
      "bbox_min": [
        -420.6841125488281,
        -1851.2620849609375,
        905.0
      ],
      "bbox_max": [
        -419.7401428222656,
        -1850.096435546875,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7677624821662903,
        -0.48038429021835327,
        -0.42399489879608154
      ],
      "plane_d": -829.48046875,
      "bbox_min": [
        -441.25640869140625,
        -1880.676025390625,
        895.0
      ],
      "bbox_max": [
        -408.69110107421875,
        -1842.89892578125,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8394879698753357,
        -0.27731165289878845,
        -0.46728816628456116
      ],
      "plane_d": -443.591064453125,
      "bbox_min": [
        -441.25640869140625,
        -1880.676025390625,
        904.5169677734375
      ],
      "bbox_max": [
        -408.69110107421875,
        -1842.89892578125,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6295140981674194,
        -0.6511096954345703,
        -0.4239906668663025
      ],
      "plane_d": -1088.3922119140625,
      "bbox_min": [
        -441.25640869140625,
        -1880.676025390625,
        904.5169677734375
      ],
      "bbox_max": [
        -408.69110107421875,
        -1842.89892578125,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8397529125213623,
        0.2772221565246582,
        0.4668649137020111
      ],
      "plane_d": 443.442626953125,
      "bbox_min": [
        -441.25640869140625,
        -1880.676025390625,
        904.5169677734375
      ],
      "bbox_max": [
        -408.69110107421875,
        -1842.89892578125,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364973545074463,
        0.1635679006576538,
        0.8278985619544983
      ],
      "plane_d": -711.151123046875,
      "bbox_min": [
        -441.25640869140625,
        -1857.0799560546875,
        921.4075317382812
      ],
      "bbox_max": [
        -428.6824035644531,
        -1842.89892578125,
        940.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -439.3348083496094,
        -1857.0799560546875,
        921.4075317382812
      ],
      "bbox_max": [
        -428.6824035644531,
        -1849.6146240234375,
        940.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4296165108680725,
        -0.13796882331371307,
        0.8924092054367065
      ],
      "plane_d": -1284.1937255859375,
      "bbox_min": [
        -439.3348083496094,
        -1856.866455078125,
        940.7503662109375
      ],
      "bbox_max": [
        -438.2117004394531,
        -1854.6763916015625,
        940.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4457895755767822,
        -0.7634869813919067,
        -0.46728917956352234
      ],
      "plane_d": -1180.87939453125,
      "bbox_min": [
        -438.9306335449219,
        -1880.676025390625,
        904.5169677734375
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7679875493049622,
        0.48043879866600037,
        0.42352527379989624
      ],
      "plane_d": 829.6249389648438,
      "bbox_min": [
        -438.9306335449219,
        -1880.676025390625,
        905.845703125
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4296165108680725,
        -0.13796882331371307,
        0.8924092054367065
      ],
      "plane_d": -1284.1937255859375,
      "bbox_min": [
        -438.9306335449219,
        -1868.34765625,
        905.845703125
      ],
      "bbox_max": [
        -418.2311706542969,
        -1854.6763916015625,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22449181973934174,
        -0.3917650282382965,
        0.892257571220398
      ],
      "plane_d": -1669.1064453125,
      "bbox_min": [
        -432.613037109375,
        -1868.34765625,
        941.9049072265625
      ],
      "bbox_max": [
        -430.8908386230469,
        -1866.5487060546875,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -418.8973693847656,
        -1857.174072265625,
        905.845703125
      ],
      "bbox_max": [
        -418.2311706542969,
        -1856.4063720703125,
        906.6109619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6296146512031555,
        0.6513081789016724,
        0.4235362112522125
      ],
      "plane_d": 1088.737548828125,
      "bbox_min": [
        -432.261474609375,
        -1880.676025390625,
        906.2737426757812
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22449181973934174,
        -0.3917650282382965,
        0.892257571220398
      ],
      "plane_d": -1669.1064453125,
      "bbox_min": [
        -432.261474609375,
        -1876.695068359375,
        906.2737426757812
      ],
      "bbox_max": [
        -417.0255126953125,
        -1856.2801513671875,
        942.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04848303273320198,
        -0.5587282776832581,
        0.8279325366020203
      ],
      "plane_d": -1806.5194091796875,
      "bbox_min": [
        -422.3056945800781,
        -1876.695068359375,
        940.0906982421875
      ],
      "bbox_max": [
        -420.24615478515625,
        -1875.54052734375,
        940.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -419.037841796875,
        -1858.8408203125,
        906.2737426757812
      ],
      "bbox_max": [
        -417.0255126953125,
        -1856.2801513671875,
        907.8468627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -417.44744873046875,
        -1858.8408203125,
        907.7763671875
      ],
      "bbox_max": [
        -417.0255126953125,
        -1858.3870849609375,
        907.8468627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -430.3176574707031,
        -1880.676025390625,
        906.8453979492188
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        940.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.445747971534729,
        0.7637674808502197,
        0.46687033772468567
      ],
      "plane_d": 1181.28515625,
      "bbox_min": [
        -430.3176574707031,
        -1880.676025390625,
        906.900634765625
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        940.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4328785538673401,
        -0.4926200807094574,
        -0.7549447417259216
      ],
      "plane_d": -404.15673828125,
      "bbox_min": [
        -420.1971435546875,
        -1880.676025390625,
        907.1475219726562
      ],
      "bbox_max": [
        -408.7774658203125,
        -1856.8741455078125,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -413.965087890625,
        -1880.676025390625,
        920.717529296875
      ],
      "bbox_max": [
        -408.7774658203125,
        -1868.0003662109375,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3474840819835663,
        -0.6135398149490356,
        0.7091005444526672
      ],
      "plane_d": -1675.695068359375,
      "bbox_min": [
        -409.9819030761719,
        -1880.676025390625,
        936.26708984375
      ],
      "bbox_max": [
        -408.7774658203125,
        -1880.28271484375,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -418.5894775390625,
        -1859.3397216796875,
        907.1475219726562
      ],
      "bbox_max": [
        -415.5345458984375,
        -1856.8741455078125,
        908.6363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -418.5894775390625,
        -1859.3397216796875,
        907.1475219726562
      ],
      "bbox_max": [
        -415.5345458984375,
        -1856.8741455078125,
        908.6363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -416.2085266113281,
        -1859.3397216796875,
        907.3180541992188
      ],
      "bbox_max": [
        -415.5345458984375,
        -1858.7939453125,
        908.6363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.244363471865654,
        0.8007124662399292,
        0.5469425320625305
      ],
      "plane_d": 1093.1910400390625,
      "bbox_min": [
        -430.3176574707031,
        -1880.47412109375,
        906.900634765625
      ],
      "bbox_max": [
        -408.69110107421875,
        -1849.481201171875,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -417.26202392578125,
        -1880.47412109375,
        907.3717651367188
      ],
      "bbox_max": [
        -408.69110107421875,
        -1858.2607421875,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3474840819835663,
        -0.6135398149490356,
        0.7091005444526672
      ],
      "plane_d": -1675.695068359375,
      "bbox_min": [
        -409.8081359863281,
        -1880.47412109375,
        936.3875732421875
      ],
      "bbox_max": [
        -408.69110107421875,
        -1880.261962890625,
        937.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -417.26202392578125,
        -1859.2431640625,
        907.3717651367188
      ],
      "bbox_max": [
        -415.34014892578125,
        -1858.2607421875,
        908.8784790039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -416.08929443359375,
        -1859.2431640625,
        907.3717651367188
      ],
      "bbox_max": [
        -415.34014892578125,
        -1858.636474609375,
        908.8784790039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4977271854877472,
        0.45295774936676025,
        0.7396600246429443
      ],
      "plane_d": 371.02935791015625,
      "bbox_min": [
        -430.3176574707031,
        -1868.7601318359375,
        906.900634765625
      ],
      "bbox_max": [
        -412.2359619140625,
        -1849.481201171875,
        924.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -428.547607421875,
        -1867.8153076171875,
        906.900634765625
      ],
      "bbox_max": [
        -412.9183044433594,
        -1852.122802734375,
        923.6314086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -427.7413024902344,
        -1866.8165283203125,
        911.7919921875
      ],
      "bbox_max": [
        -412.9183044433594,
        -1852.122802734375,
        922.0418701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -427.7413024902344,
        -1856.368896484375,
        911.7919921875
      ],
      "bbox_max": [
        -413.0997314453125,
        -1852.122802734375,
        922.0418701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2954280376434326,
        -0.49007007479667664,
        -0.8200936317443848
      ],
      "plane_d": -283.0264892578125,
      "bbox_min": [
        -414.15948486328125,
        -1856.368896484375,
        911.7919921875
      ],
      "bbox_max": [
        -413.0997314453125,
        -1854.124755859375,
        913.0245971679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661365628242493,
        -0.5393994450569153,
        0.5150827765464783
      ],
      "plane_d": -1751.37060546875,
      "bbox_min": [
        -421.0084228515625,
        -1853.43896484375,
        915.7816162109375
      ],
      "bbox_max": [
        -420.2190856933594,
        -1852.3880615234375,
        915.9063720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293261647224426,
        -0.7771412134170532,
        9.447147022001445e-06
      ],
      "plane_d": -1185.3472900390625,
      "bbox_min": [
        -414.4456481933594,
        -1860.5986328125,
        914.93408203125
      ],
      "bbox_max": [
        -412.92218017578125,
        -1859.6380615234375,
        916.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661583185195923,
        -0.5394244194030762,
        0.5150285959243774
      ],
      "plane_d": -1751.376220703125,
      "bbox_min": [
        -416.93450927734375,
        -1860.6978759765625,
        914.6095581054688
      ],
      "bbox_max": [
        -412.9716796875,
        -1857.4951171875,
        916.1864624023438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661367416381836,
        -0.5393844246864319,
        0.5150983333587646
      ],
      "plane_d": -1751.3570556640625,
      "bbox_min": [
        -421.121826171875,
        -1855.5006103515625,
        915.5615844726562
      ],
      "bbox_max": [
        -418.6181640625,
        -1852.4224853515625,
        915.8253173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661518812179565,
        -0.5394379496574402,
        0.5150227546691895
      ],
      "plane_d": -1751.3935546875,
      "bbox_min": [
        -421.89556884765625,
        -1861.5155029296875,
        912.7186889648438
      ],
      "bbox_max": [
        -413.10638427734375,
        -1852.5343017578125,
        915.9239501953125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -419.4624938964844,
        -1859.151611328125,
        906.900634765625
      ],
      "bbox_max": [
        -413.80670166015625,
        -1854.081787109375,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -419.4624938964844,
        -1859.151611328125,
        906.900634765625
      ],
      "bbox_max": [
        -413.80670166015625,
        -1855.898681640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -419.4624938964844,
        -1857.510986328125,
        906.900634765625
      ],
      "bbox_max": [
        -418.15692138671875,
        -1855.898681640625,
        907.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.432862788438797,
        0.49263185262680054,
        0.7549461126327515
      ],
      "plane_d": 403.68096923828125,
      "bbox_min": [
        -430.3176574707031,
        -1868.7601318359375,
        912.2163696289062
      ],
      "bbox_max": [
        -412.2359619140625,
        -1849.481201171875,
        924.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -414.44183349609375,
        -1868.0003662109375,
        915.09814453125
      ],
      "bbox_max": [
        -412.4697265625,
        -1859.7103271484375,
        921.0867919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4328785538673401,
        -0.4926200807094574,
        -0.7549447417259216
      ],
      "plane_d": -404.15673828125,
      "bbox_min": [
        -414.44183349609375,
        -1868.000244140625,
        920.20263671875
      ],
      "bbox_max": [
        -413.965087890625,
        -1866.81494140625,
        921.0867919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5465455055236816,
        0.39267194271087646,
        0.7396597862243652
      ],
      "plane_d": 279.60552978515625,
      "bbox_min": [
        -430.3176574707031,
        -1868.7601318359375,
        912.2163696289062
      ],
      "bbox_max": [
        -412.2359619140625,
        -1849.481201171875,
        924.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -429.6240234375,
        -1855.4139404296875,
        916.49658203125
      ],
      "bbox_max": [
        -421.9015197753906,
        -1849.9150390625,
        922.9842529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.546542227268219,
        -0.3926725387573242,
        -0.7396619915962219
      ],
      "plane_d": -280.09307861328125,
      "bbox_min": [
        -428.80889892578125,
        -1855.4139404296875,
        922.0418701171875
      ],
      "bbox_max": [
        -427.7413024902344,
        -1854.7611083984375,
        922.9842529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36181771755218506,
        0.5056677460670471,
        0.7831909656524658
      ],
      "plane_d": 372.61016845703125,
      "bbox_min": [
        -430.3176574707031,
        -1868.7601318359375,
        912.2163696289062
      ],
      "bbox_max": [
        -412.2359619140625,
        -1849.481201171875,
        924.04638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718623995780945,
        0.32098817825317383,
        0.7549437284469604
      ],
      "plane_d": 143.3858642578125,
      "bbox_min": [
        -430.3176574707031,
        -1856.1678466796875,
        912.2163696289062
      ],
      "bbox_max": [
        -412.9181823730469,
        -1849.481201171875,
        924.04638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29542335867881775,
        0.49008437991142273,
        0.8200867772102356
      ],
      "plane_d": 282.5673828125,
      "bbox_min": [
        -413.96734619140625,
        -1856.1678466796875,
        912.2163696289062
      ],
      "bbox_max": [
        -412.9181823730469,
        -1853.9462890625,
        913.4364624023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -417.2024230957031,
        -1859.4310302734375,
        906.8453979492188
      ],
      "bbox_max": [
        -415.5568542480469,
        -1858.650634765625,
        908.3810424804688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -417.2024230957031,
        -1859.4310302734375,
        907.8173217773438
      ],
      "bbox_max": [
        -416.2085266113281,
        -1858.650634765625,
        908.3810424804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -418.5262756347656,
        -1859.568359375,
        904.5169677734375
      ],
      "bbox_max": [
        -415.7530517578125,
        -1856.73974609375,
        908.1394653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4002443253993988,
        -0.3241121768951416,
        -0.8571790456771851
      ],
      "plane_d": 6.7198486328125,
      "bbox_min": [
        -417.7560119628906,
        -1859.568359375,
        904.5169677734375
      ],
      "bbox_max": [
        -415.7530517578125,
        -1857.0738525390625,
        908.1394653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293101906776428,
        -0.777154266834259,
        -1.348546902590897e-05
      ],
      "plane_d": -1183.057373046875,
      "bbox_min": [
        -417.1952209472656,
        -1859.568359375,
        905.9939575195312
      ],
      "bbox_max": [
        -415.7530517578125,
        -1858.6986083984375,
        908.1394653320312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -417.1952209472656,
        -1859.568359375,
        907.7763671875
      ],
      "bbox_max": [
        -416.3213195800781,
        -1858.6986083984375,
        908.1394653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -418.4624938964844,
        -1859.5076904296875,
        904.9000854492188
      ],
      "bbox_max": [
        -416.10650634765625,
        -1856.7969970703125,
        906.8385620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293101906776428,
        -0.777154266834259,
        -1.348546902590897e-05
      ],
      "plane_d": -1183.057373046875,
      "bbox_min": [
        -416.4160461425781,
        -1859.5076904296875,
        905.5046997070312
      ],
      "bbox_max": [
        -416.10650634765625,
        -1859.257080078125,
        906.8385620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500045895576477,
        -0.8659989833831787,
        -0.0
      ],
      "plane_d": -1827.48974609375,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -416.96551513671875,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660057783126831,
        -0.5000341534614563,
        -0.0
      ],
      "plane_d": -1301.59619140625,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -416.96551513671875,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -902.9999389648438,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.7542114257812
      ],
      "bbox_max": [
        -416.96551513671875,
        -1856.9609375,
        905.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.11572265625,
      "bbox_min": [
        -430.11572265625,
        -1858.10009765625,
        902.3323364257812
      ],
      "bbox_max": [
        -430.11572265625,
        -1857.8133544921875,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.485130250453949,
        -0.8401674628257751,
        0.2424197494983673
      ],
      "plane_d": -1991.88330078125,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850674867630005,
        0.8401495814323425,
        0.24260728061199188
      ],
      "plane_d": 1551.90380859375,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -426.815673828125,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370622634887695,
        -0.25119492411613464,
        0.24251866340637207
      ],
      "plane_d": -293.4073181152344,
      "bbox_min": [
        -426.815673828125,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859249472618103,
        0.6860393285751343,
        0.24260465800762177
      ],
      "plane_d": 766.8150634765625,
      "bbox_min": [
        -426.815673828125,
        -1863.8154296875,
        903.0
      ],
      "bbox_max": [
        -425.269287109375,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -636.283203125,
      "bbox_min": [
        -430.11572265625,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -428.4011535644531,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511908710002899,
        -0.9370471835136414,
        0.2425812929868698
      ],
      "plane_d": -1852.13720703125,
      "bbox_min": [
        -430.11572265625,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -428.4011535644531,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -904.9999389648438,
      "bbox_min": [
        -429.6155090332031,
        -1857.4482421875,
        904.1417236328125
      ],
      "bbox_max": [
        -428.4011535644531,
        -1856.9609375,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": 196.3236083984375,
      "bbox_min": [
        -428.61572265625,
        -1857.344970703125,
        904.1417236328125
      ],
      "bbox_max": [
        -428.4011535644531,
        -1856.9737548828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 349.87347412109375,
      "bbox_min": [
        -421.3465881347656,
        -1884.9921875,
        895.0
      ],
      "bbox_max": [
        -361.5999755859375,
        -1769.9007568359375,
        939.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 1819.7392578125,
      "bbox_min": [
        -421.3465881347656,
        -1884.9921875,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1769.9007568359375,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 1860.235595703125,
      "bbox_min": [
        -421.3465881347656,
        -1884.9921875,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1832.0,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -377.0601501464844,
      "bbox_min": [
        -411.2259521484375,
        -1884.9921875,
        895.0
      ],
      "bbox_max": [
        -362.01055908203125,
        -1872.5,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -364.98944091796875,
        -1884.9921875,
        895.7810668945312
      ],
      "bbox_max": [
        -362.01055908203125,
        -1873.0,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -364.4751892089844,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1873.0,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300142765045166,
        -0.0,
        0.8479886054992676
      ],
      "plane_d": -598.7041015625,
      "bbox_min": [
        -364.4751892089844,
        -1874.9783935546875,
        933.60009765625
      ],
      "bbox_max": [
        -364.099853515625,
        -1873.021728515625,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.5,
        -1884.9921875,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1874.9752197265625,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300138592720032,
        -1.3653190762852319e-05,
        0.8479890823364258
      ],
      "plane_d": -598.7302856445312,
      "bbox_min": [
        -364.476318359375,
        -1884.9921875,
        933.60009765625
      ],
      "bbox_max": [
        -364.099853515625,
        -1874.9752197265625,
        933.834716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1915.627197265625,
      "bbox_min": [
        -364.476318359375,
        -1884.9921875,
        933.7521362304688
      ],
      "bbox_max": [
        -364.43896484375,
        -1884.990478515625,
        933.8345336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.5,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1874.9783935546875,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -364.099853515625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1874.9783935546875,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -411.2259521484375,
        -1884.9921875,
        921.4956665039062
      ],
      "bbox_max": [
        -364.4751892089844,
        -1872.858154296875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300138592720032,
        -1.3653190762852319e-05,
        0.8479890823364258
      ],
      "plane_d": -598.7302856445312,
      "bbox_min": [
        -410.94549560546875,
        -1884.9921875,
        921.4956665039062
      ],
      "bbox_max": [
        -364.4751892089844,
        -1872.858154296875,
        939.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.05644569545984268,
        -0.7562670707702637,
        -0.6518236398696899
      ],
      "plane_d": -837.777099609375,
      "bbox_min": [
        -410.94549560546875,
        -1880.655029296875,
        921.4956665039062
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.858154296875,
        936.5289306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.244363471865654,
        0.8007124662399292,
        0.5469425320625305
      ],
      "plane_d": 1093.1910400390625,
      "bbox_min": [
        -410.94549560546875,
        -1880.655029296875,
        921.4956665039062
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.858154296875,
        936.5289306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3474840819835663,
        -0.6135398149490356,
        0.7091005444526672
      ],
      "plane_d": -1675.695068359375,
      "bbox_min": [
        -408.85107421875,
        -1880.655029296875,
        930.8955078125
      ],
      "bbox_max": [
        -397.442138671875,
        -1880.05322265625,
        936.5289306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05614412948489189,
        0.756541907787323,
        0.6515306830406189
      ],
      "plane_d": 837.9493408203125,
      "bbox_min": [
        -403.46282958984375,
        -1880.05322265625,
        921.4956665039062
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.858154296875,
        931.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08989904820919037,
        -0.6377612948417664,
        -0.7649697661399841
      ],
      "plane_d": -454.40386962890625,
      "bbox_min": [
        -390.618408203125,
        -1875.2379150390625,
        921.4956665039062
      ],
      "bbox_max": [
        -385.58837890625,
        -1872.858154296875,
        924.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -386.81982421875,
        -1875.2379150390625,
        922.7626953125
      ],
      "bbox_max": [
        -385.58837890625,
        -1873.6688232421875,
        924.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09031923115253448,
        0.6379223465919495,
        0.7647859454154968
      ],
      "plane_d": 454.21649169921875,
      "bbox_min": [
        -390.052734375,
        -1874.8873291015625,
        921.9398193359375
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.8642578125,
        924.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -386.88201904296875,
        -1874.8873291015625,
        921.9398193359375
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.8642578125,
        924.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08989904820919037,
        -0.6377612948417664,
        -0.7649697661399841
      ],
      "plane_d": -454.40386962890625,
      "bbox_min": [
        -386.88201904296875,
        -1873.6688232421875,
        921.9398193359375
      ],
      "bbox_max": [
        -384.96356201171875,
        -1872.8642578125,
        922.7626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -373.4189453125,
        -1884.9921875,
        932.0
      ],
      "bbox_max": [
        -364.4751892089844,
        -1873.0,
        939.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -738.036376953125,
      "bbox_min": [
        -373.4189453125,
        -1884.9921875,
        932.7311401367188
      ],
      "bbox_max": [
        -364.4751892089844,
        -1873.0826416015625,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -373.4189453125,
        -1884.9921875,
        932.7311401367188
      ],
      "bbox_max": [
        -364.4751892089844,
        -1875.0,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1915.627197265625,
      "bbox_min": [
        -373.4189453125,
        -1884.9921875,
        933.01171875
      ],
      "bbox_max": [
        -364.4751892089844,
        -1884.592041015625,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.7311401367188
      ],
      "bbox_max": [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479329347610474,
        0.0,
        0.5301035642623901
      ],
      "plane_d": -813.6368408203125,
      "bbox_min": [
        -373.0906066894531,
        -1874.60009765625,
        938.0999755859375
      ],
      "bbox_max": [
        -372.57958984375,
        -1873.0826416015625,
        938.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        -0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -887.8880615234375,
      "bbox_min": [
        -373.0906066894531,
        -1873.39990234375,
        938.0999755859375
      ],
      "bbox_max": [
        -372.57958984375,
        -1873.0826416015625,
        938.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -364.4901123046875,
        -1873.0,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -364.4901123046875,
        -1875.0,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -377.0601501464844,
      "bbox_min": [
        -421.3465881347656,
        -1873.0933837890625,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1832.0,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1846.9259033203125,
      "bbox_min": [
        -365.0,
        -1873.02490234375,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1832.5,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -364.4751892089844,
        -1834.5,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1832.5,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300142765045166,
        -0.0,
        0.8479886054992676
      ],
      "plane_d": -598.7041015625,
      "bbox_min": [
        -364.4751892089844,
        -1834.478271484375,
        933.60009765625
      ],
      "bbox_max": [
        -364.099853515625,
        -1832.521728515625,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.5,
        -1873.02490234375,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1834.47509765625,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300138592720032,
        1.3651326298713684e-05,
        0.8479889631271362
      ],
      "plane_d": -598.6790161132812,
      "bbox_min": [
        -364.476318359375,
        -1873.02490234375,
        933.60009765625
      ],
      "bbox_max": [
        -364.099853515625,
        -1863.0078125,
        933.8346557617188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03390785679221153,
        0.9992004036903381,
        0.021187884733080864
      ],
      "plane_d": 1829.3753662109375,
      "bbox_min": [
        -364.476318359375,
        -1863.009521484375,
        933.7521362304688
      ],
      "bbox_max": [
        -364.43896484375,
        -1863.0078125,
        933.8345336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 729.688232421875,
      "bbox_min": [
        -364.5,
        -1873.021728515625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1834.47509765625,
        933.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300138592720032,
        -1.3653190762852319e-05,
        0.8479890823364258
      ],
      "plane_d": -598.729736328125,
      "bbox_min": [
        -364.476318359375,
        -1844.4921875,
        933.60009765625
      ],
      "bbox_max": [
        -364.099853515625,
        -1834.47509765625,
        933.834716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1875.1595458984375,
      "bbox_min": [
        -364.476318359375,
        -1844.4921875,
        933.7521362304688
      ],
      "bbox_max": [
        -364.43896484375,
        -1844.490478515625,
        933.8345336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1834.4998779296875,
      "bbox_min": [
        -364.5,
        -1873.021728515625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1834.478271484375,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -364.099853515625,
        -1873.021728515625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1873.0,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -421.3465881347656,
        -1873.0933837890625,
        895.0
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790639400482178,
        -0.2584279775619507,
        -0.949507474899292
      ],
      "plane_d": 453.013671875,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17219054698944092,
        -0.4629462659358978,
        -0.8695005774497986
      ],
      "plane_d": -1.14617919921875,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08989904820919037,
        -0.6377612948417664,
        -0.7649697661399841
      ],
      "plane_d": -454.40386962890625,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1061839610338211,
        -0.05535433813929558,
        -0.9928045868873596
      ],
      "plane_d": 838.9097900390625,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1726711243391037,
        0.4630064368247986,
        0.8693732023239136
      ],
      "plane_d": 0.69573974609375,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9666560292243958,
        -0.11235125362873077,
        0.23011593520641327
      ],
      "plane_d": -53.79853820800781,
      "bbox_min": [
        -398.5963439941406,
        -1867.4173583984375,
        907.0216064453125
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        918.1234741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21471019089221954,
        -0.3865227997303009,
        -0.8969390392303467
      ],
      "plane_d": 12.32232666015625,
      "bbox_min": [
        -398.5963439941406,
        -1867.4173583984375,
        907.0216064453125
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        918.1234741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -398.5963439941406,
        -1867.4173583984375,
        907.0216064453125
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        918.1234741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2126915007829666,
        -0.31433331966400146,
        -0.9251794219017029
      ],
      "plane_d": 172.6290283203125,
      "bbox_min": [
        -397.12152099609375,
        -1867.4173583984375,
        907.0216064453125
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        918.1234741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -380.715576171875,
        -1867.4173583984375,
        910.3916015625
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        918.1234741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.975101888179779,
        0.1916656643152237,
        0.11153794825077057
      ],
      "plane_d": 620.970703125,
      "bbox_min": [
        -377.0277404785156,
        -1853.704345703125,
        910.3916015625
      ],
      "bbox_max": [
        -376.6746826171875,
        -1851.524169921875,
        911.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17840266227722168,
        0.2583446204662323,
        0.9494369626045227
      ],
      "plane_d": -453.7879943847656,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.975101888179779,
        0.1916656643152237,
        0.11153794825077057
      ],
      "plane_d": 620.970703125,
      "bbox_min": [
        -398.1900634765625,
        -1854.3607177734375,
        905.3049926757812
      ],
      "bbox_max": [
        -376.7625427246094,
        -1838.6571044921875,
        911.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8685542941093445,
        0.49334651231765747,
        0.04714541137218475
      ],
      "plane_d": 1194.313232421875,
      "bbox_min": [
        -379.9106750488281,
        -1840.6561279296875,
        906.872314453125
      ],
      "bbox_max": [
        -378.78778076171875,
        -1838.6571044921875,
        907.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09031923115253448,
        0.6379223465919495,
        0.7647859454154968
      ],
      "plane_d": 454.21649169921875,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05644569545984268,
        -0.7562670707702637,
        -0.6518236398696899
      ],
      "plane_d": -837.777099609375,
      "bbox_min": [
        -403.1121520996094,
        -1872.8756103515625,
        910.8987426757812
      ],
      "bbox_max": [
        -379.55810546875,
        -1860.5015869140625,
        922.7907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -403.1121520996094,
        -1872.8756103515625,
        910.8987426757812
      ],
      "bbox_max": [
        -379.55810546875,
        -1860.5015869140625,
        922.7907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -403.1121520996094,
        -1866.9979248046875,
        910.8987426757812
      ],
      "bbox_max": [
        -398.5466003417969,
        -1860.5015869140625,
        915.7783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2954280376434326,
        -0.49007007479667664,
        -0.8200936317443848
      ],
      "plane_d": -283.0264892578125,
      "bbox_min": [
        -403.1121520996094,
        -1866.9979248046875,
        914.422607421875
      ],
      "bbox_max": [
        -401.3579406738281,
        -1865.250244140625,
        915.7783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.032068900763988495,
        0.11537075787782669,
        -0.9928047060966492
      ],
      "plane_d": 1097.8153076171875,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.141357421875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10662446916103363,
        0.05510290339589119,
        0.9927712678909302
      ],
      "plane_d": -840.0062866210938,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.1473388671875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8685542941093445,
        0.49334651231765747,
        0.04714541137218475
      ],
      "plane_d": 1194.313232421875,
      "bbox_min": [
        -402.3418884277344,
        -1847.7623291015625,
        904.7818603515625
      ],
      "bbox_max": [
        -378.8591613769531,
        -1832.1502685546875,
        907.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2380163073539734,
        -0.24262867867946625,
        -0.9404677152633667
      ],
      "plane_d": 308.8880615234375,
      "bbox_min": [
        -402.3418884277344,
        -1847.7623291015625,
        904.7818603515625
      ],
      "bbox_max": [
        -398.1166687011719,
        -1839.4686279296875,
        905.9151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -402.3418884277344,
        -1841.7109375,
        904.7818603515625
      ],
      "bbox_max": [
        -400.6534729003906,
        -1839.4686279296875,
        905.2142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5300138592720032,
        -1.3653190762852319e-05,
        0.8479890823364258
      ],
      "plane_d": -598.729736328125,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        905.0089111328125
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.1473388671875,
        939.1119384765625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.05644569545984268,
        -0.7562670707702637,
        -0.6518236398696899
      ],
      "plane_d": -837.777099609375,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        905.0089111328125
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.1473388671875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7859497070312,
      "bbox_min": [
        -413.8913269042969,
        -1873.0933837890625,
        905.0089111328125
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.1473388671875,
        939.1119384765625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1875.1595458984375,
      "bbox_min": [
        -373.4189453125,
        -1873.0933837890625,
        932.73046875
      ],
      "bbox_max": [
        -364.4751892089844,
        -1832.5826416015625,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -739.6556396484375,
      "bbox_min": [
        -373.4189453125,
        -1844.4921875,
        932.7311401367188
      ],
      "bbox_max": [
        -364.476318359375,
        -1832.5826416015625,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 729.688232421875,
      "bbox_min": [
        -364.93896484375,
        -1844.4921875,
        932.7311401367188
      ],
      "bbox_max": [
        -364.476318359375,
        -1834.5,
        933.7521362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1834.4998779296875,
      "bbox_min": [
        -364.60009765625,
        -1834.5,
        932.7311401367188
      ],
      "bbox_max": [
        -364.4867248535156,
        -1834.5,
        932.9812622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479329347610474,
        0.0,
        0.5301035642623901
      ],
      "plane_d": -813.6368408203125,
      "bbox_min": [
        -373.0906066894531,
        -1834.10009765625,
        938.0999755859375
      ],
      "bbox_max": [
        -372.57958984375,
        -1832.5826416015625,
        938.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        -0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -886.268798828125,
      "bbox_min": [
        -373.0906066894531,
        -1832.89990234375,
        938.0999755859375
      ],
      "bbox_max": [
        -372.57958984375,
        -1832.5826416015625,
        938.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -373.4189453125,
        -1873.0933837890625,
        932.73046875
      ],
      "bbox_max": [
        -364.4751892089844,
        -1863.0078125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390785679221153,
        0.9992004036903381,
        0.021187884733080864
      ],
      "plane_d": 1829.3753662109375,
      "bbox_min": [
        -373.4189453125,
        -1873.0933837890625,
        933.01171875
      ],
      "bbox_max": [
        -364.4751892089844,
        -1863.0078125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        -0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -887.8880615234375,
      "bbox_min": [
        -373.4189453125,
        -1873.0933837890625,
        938.106689453125
      ],
      "bbox_max": [
        -372.5899963378906,
        -1863.407958984375,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1872.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1873.0,
        932.73046875
      ],
      "bbox_max": [
        -364.4867248535156,
        -1873.0,
        932.9812622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05614412948489189,
        0.756541907787323,
        0.6515306830406189
      ],
      "plane_d": 837.9493408203125,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.0089111328125
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.1473388671875,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -409.1952209472656,
        -1872.88671875,
        914.422607421875
      ],
      "bbox_max": [
        -402.247802734375,
        -1865.250244140625,
        923.6090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2954280376434326,
        -0.49007007479667664,
        -0.8200936317443848
      ],
      "plane_d": -283.0264892578125,
      "bbox_min": [
        -409.1952209472656,
        -1869.0006103515625,
        914.422607421875
      ],
      "bbox_max": [
        -402.247802734375,
        -1865.250244140625,
        919.3761596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -409.1952209472656,
        -1869.0006103515625,
        917.9464721679688
      ],
      "bbox_max": [
        -407.1524353027344,
        -1867.883056640625,
        919.3761596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03173423558473587,
        -0.11574684828519821,
        0.9927716255187988
      ],
      "plane_d": -1099.09912109375,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.0089111328125
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.1473388671875,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -408.2506408691406,
        -1841.7109375,
        905.0089111328125
      ],
      "bbox_max": [
        -401.58929443359375,
        -1832.1473388671875,
        906.478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21578966081142426,
        0.22774909436702728,
        -0.9495078325271606
      ],
      "plane_d": 1190.307373046875,
      "bbox_min": [
        -408.2506408691406,
        -1837.1279296875,
        905.531982421875
      ],
      "bbox_max": [
        -403.7577209472656,
        -1832.1473388671875,
        906.478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -408.2506408691406,
        -1837.1279296875,
        905.531982421875
      ],
      "bbox_max": [
        -406.2318115234375,
        -1835.265380859375,
        906.1786499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.2142333984375
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.154052734375,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.244363471865654,
        0.8007124662399292,
        0.5469425320625305
      ],
      "plane_d": 1093.1910400390625,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.2142333984375
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.154052734375,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -412.4697265625,
        -1869.0601806640625,
        917.9464721679688
      ],
      "bbox_max": [
        -407.66229248046875,
        -1867.883056640625,
        920.9002075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21578966081142426,
        0.22774909436702728,
        -0.9495078325271606
      ],
      "plane_d": 1190.307373046875,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.2142333984375
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.154052734375,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -413.8913269042969,
        -1873.0108642578125,
        905.2142333984375
      ],
      "bbox_max": [
        -364.4901123046875,
        -1832.154052734375,
        932.7999267578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -411.5560607910156,
        -1837.1279296875,
        905.9151611328125
      ],
      "bbox_max": [
        -406.8018798828125,
        -1834.0316162109375,
        907.43798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2380163073539734,
        -0.24262867867946625,
        -0.9404677152633667
      ],
      "plane_d": 308.8880615234375,
      "bbox_min": [
        -413.8913269042969,
        -1868.7327880859375,
        905.2142333984375
      ],
      "bbox_max": [
        -395.8621826171875,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -413.73931884765625,
        -1868.7327880859375,
        905.2142333984375
      ],
      "bbox_max": [
        -395.8621826171875,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -413.73931884765625,
        -1868.7327880859375,
        905.2762451171875
      ],
      "bbox_max": [
        -395.8621826171875,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -413.2013244628906,
        -1868.7327880859375,
        905.2762451171875
      ],
      "bbox_max": [
        -395.8621826171875,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21471019089221954,
        -0.3865227997303009,
        -0.8969390392303467
      ],
      "plane_d": 12.32232666015625,
      "bbox_min": [
        -413.2013244628906,
        -1864.8885498046875,
        906.0679931640625
      ],
      "bbox_max": [
        -397.12152099609375,
        -1848.1259765625,
        914.1903686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2126915007829666,
        -0.31433331966400146,
        -0.9251794219017029
      ],
      "plane_d": 172.6290283203125,
      "bbox_min": [
        -413.2013244628906,
        -1864.8885498046875,
        906.0679931640625
      ],
      "bbox_max": [
        -397.12152099609375,
        -1848.1259765625,
        914.1903686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -413.2013244628906,
        -1864.8885498046875,
        910.8987426757812
      ],
      "bbox_max": [
        -398.5466003417969,
        -1853.3485107421875,
        914.1903686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293339729309082,
        -0.7771350145339966,
        1.597722621227149e-05
      ],
      "plane_d": -1185.3385009765625,
      "bbox_min": [
        -410.1022033691406,
        -1857.3544921875,
        911.178466796875
      ],
      "bbox_max": [
        -408.18115234375,
        -1855.798828125,
        912.53369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661423444747925,
        0.5394482612609863,
        -0.5150243043899536
      ],
      "plane_d": 1739.2099609375,
      "bbox_min": [
        -408.94635009765625,
        -1853.3729248046875,
        909.42431640625
      ],
      "bbox_max": [
        -406.6152648925781,
        -1850.8131103515625,
        909.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293129324913025,
        -0.7771519422531128,
        5.953171239525545e-06
      ],
      "plane_d": -1185.369384765625,
      "bbox_min": [
        -409.2225341796875,
        -1856.64208984375,
        909.4751586914062
      ],
      "bbox_max": [
        -405.98822021484375,
        -1851.9580078125,
        911.7911376953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6661423444747925,
        0.5394482612609863,
        -0.5150243043899536
      ],
      "plane_d": 1739.2099609375,
      "bbox_min": [
        -407.97991943359375,
        -1854.142578125,
        909.4751586914062
      ],
      "bbox_max": [
        -405.98822021484375,
        -1851.9580078125,
        909.88818359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21268339455127716,
        0.3143380582332611,
        0.9251796007156372
      ],
      "plane_d": -173.11376953125,
      "bbox_min": [
        -413.01873779296875,
        -1868.7327880859375,
        905.2762451171875
      ],
      "bbox_max": [
        -395.8621826171875,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24374565482139587,
        0.4482356011867523,
        0.8600425124168396
      ],
      "plane_d": 147.18524169921875,
      "bbox_min": [
        -413.01873779296875,
        -1868.7327880859375,
        905.2762451171875
      ],
      "bbox_max": [
        -396.9942932128906,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -403.2135314941406,
        -1865.250244140625,
        914.1542358398438
      ],
      "bbox_max": [
        -401.9659118652344,
        -1864.2794189453125,
        914.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29542335867881775,
        0.49008437991142273,
        0.8200867772102356
      ],
      "plane_d": 282.5673828125,
      "bbox_min": [
        -413.0035705566406,
        -1868.7327880859375,
        906.0189208984375
      ],
      "bbox_max": [
        -401.29327392578125,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3516869843006134,
        0.1426827609539032,
        0.9251800179481506
      ],
      "plane_d": -433.4312438964844,
      "bbox_min": [
        -412.9181823730469,
        -1868.7327880859375,
        906.0189208984375
      ],
      "bbox_max": [
        -406.1185302734375,
        -1834.0538330078125,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36181771755218506,
        0.5056677460670471,
        0.7831909656524658
      ],
      "plane_d": 372.61016845703125,
      "bbox_min": [
        -412.9181823730469,
        -1868.7327880859375,
        913.4364624023438
      ],
      "bbox_max": [
        -407.0299072265625,
        -1856.1678466796875,
        921.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293261647224426,
        -0.7771412134170532,
        9.447147022001445e-06
      ],
      "plane_d": -1185.3472900390625,
      "bbox_min": [
        -412.9649658203125,
        -1859.6727294921875,
        914.0799560546875
      ],
      "bbox_max": [
        -411.9338684082031,
        -1858.8377685546875,
        915.0532836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293280720710754,
        -0.7771397233009338,
        1.0289868441759609e-05
      ],
      "plane_d": -1185.344482421875,
      "bbox_min": [
        -413.73931884765625,
        -1860.2998046875,
        910.0394287109375
      ],
      "bbox_max": [
        -407.1474914550781,
        -1854.9617919921875,
        914.9502563476562
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -412.6650695800781,
        -1847.0146484375,
        909.42431640625
      ],
      "bbox_max": [
        -412.02227783203125,
        -1846.158935546875,
        909.52587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661622524261475,
        0.5394551753997803,
        -0.514991283416748
      ],
      "plane_d": 1739.200927734375,
      "bbox_min": [
        -412.7666320800781,
        -1848.9451904296875,
        909.2236328125
      ],
      "bbox_max": [
        -410.52301025390625,
        -1846.1868896484375,
        909.4598999023438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6661587357521057,
        0.5394434928894043,
        -0.5150080323219299
      ],
      "plane_d": 1739.193115234375,
      "bbox_min": [
        -413.8913269042969,
        -1860.4229736328125,
        907.478271484375
      ],
      "bbox_max": [
        -406.13580322265625,
        -1846.2869873046875,
        913.0848999023438
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.6293280720710754,
        -0.7771397233009338,
        1.0289868441759609e-05
      ],
      "plane_d": -1185.344482421875,
      "bbox_min": [
        -413.8913269042969,
        -1860.4229736328125,
        907.478271484375
      ],
      "bbox_max": [
        -406.13580322265625,
        -1854.142578125,
        913.0848999023438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -903.0,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.484375,
        911.5341796875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 405.484375,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.484375,
        903.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660150170326233,
        -0.5000181198120117,
        0.0
      ],
      "plane_d": -577.9281005859375,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660150170326233,
        0.5000181198120117,
        0.0
      ],
      "plane_d": 1276.9390869140625,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        -0.8660310506820679,
        0.0
      ],
      "plane_d": -1409.7340087890625,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000181198120117,
        0.8660150170326233,
        0.0
      ],
      "plane_d": 1802.876708984375,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.699045555549674e-05,
        -1.0,
        0.0
      ],
      "plane_d": -1867.10009765625,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -414.5,
        -1842.484375,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1842.484375,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -414.5,
        -1842.484375,
        902.6055297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500045895576477,
        -0.8659989833831787,
        -0.0
      ],
      "plane_d": -1827.48974609375,
      "bbox_min": [
        -421.3465881347656,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -421.10009765625,
        -1866.973388671875,
        895.7542114257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 174.3679656982422,
      "bbox_min": [
        -416.5555114746094,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.558837890625,
        911.5341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850599765777588,
        -0.8401700854301453,
        0.2425508350133896
      ],
      "plane_d": -1586.66064453125,
      "bbox_min": [
        -416.5555114746094,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.558837890625,
        911.5341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.485092431306839,
        0.8401641845703125,
        0.242506742477417
      ],
      "plane_d": 1530.07666015625,
      "bbox_min": [
        -416.5555114746094,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.558837890625,
        911.5341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48506924510002136,
        0.8401526212692261,
        0.24259306490421295
      ],
      "plane_d": 1146.5989990234375,
      "bbox_min": [
        -416.5555114746094,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1843.4625244140625,
        911.5341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -904.9999389648438,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859986186027527,
        0.6859986186027527,
        0.24251124262809753
      ],
      "plane_d": 1340.0128173828125,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370298981666565,
        -0.25121691823005676,
        0.24262097477912903
      ],
      "plane_d": -1076.53662109375,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -414.185791015625,
        -1865.11572265625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701425433158875,
        0.0,
        0.24253563582897186
      ],
      "plane_d": -614.32763671875,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1843.4625244140625,
        911.5341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -407.484375,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1851.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2511959671974182,
        -0.9370661973953247,
        0.24250248074531555
      ],
      "plane_d": -2061.99853515625,
      "bbox_min": [
        -407.484375,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1851.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2511889934539795,
        0.9370402097702026,
        0.2426101565361023
      ],
      "plane_d": 1413.999755859375,
      "bbox_min": [
        -407.484375,
        -1852.419677734375,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1851.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1843.4625244140625,
        911.5341796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6661451458930969,
        0.5394249558448792,
        -0.5150449872016907
      ],
      "plane_d": 1742.586669921875,
      "bbox_min": [
        -416.3686218261719,
        -1859.4215087890625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1843.4625244140625,
        909.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -416.3686218261719,
        -1859.4215087890625,
        904.0018310546875
      ],
      "bbox_max": [
        -412.8271484375,
        -1853.320068359375,
        905.5046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4002443253993988,
        -0.3241121768951416,
        -0.8571790456771851
      ],
      "plane_d": 6.7198486328125,
      "bbox_min": [
        -416.3686218261719,
        -1859.4215087890625,
        904.0018310546875
      ],
      "bbox_max": [
        -414.626953125,
        -1856.0218505859375,
        905.5046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -416.3686218261719,
        -1859.4215087890625,
        905.2894287109375
      ],
      "bbox_max": [
        -416.29241943359375,
        -1859.3134765625,
        905.5046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4850674867630005,
        -0.8401495814323425,
        0.24260728061199188
      ],
      "plane_d": -1970.0377197265625,
      "bbox_min": [
        -414.7251892089844,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1843.4625244140625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -413.98297119140625,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1843.4625244140625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.68598473072052,
        -0.68598473072052,
        0.2425900548696518
      ],
      "plane_d": -1204.81884765625,
      "bbox_min": [
        -410.330810546875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1845.784423828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6293244361877441,
        0.7771427035331726,
        -7.511625426559476e-06
      ],
      "plane_d": 1184.548828125,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -409.9307556152344,
        -1857.460205078125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293194890022278,
        -0.7771466374397278,
        -3.342030083786085e-07
      ],
      "plane_d": -1187.0511474609375,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -409.9307556152344,
        -1857.460205078125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7276643514633179,
        0.5892499685287476,
        0.351125568151474
      ],
      "plane_d": 1076.87890625,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -409.9307556152344,
        -1857.460205078125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7276657819747925,
        -0.5892511010169983,
        0.3511207103729248
      ],
      "plane_d": -1717.09619140625,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -411.09649658203125,
        -1858.4041748046875,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -907.0,
      "bbox_min": [
        -415.3898010253906,
        -1862.5496826171875,
        907.0
      ],
      "bbox_max": [
        -411.09649658203125,
        -1858.4041748046875,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -906.5,
      "bbox_min": [
        -415.6344299316406,
        -1860.04052734375,
        905.0
      ],
      "bbox_max": [
        -413.4469299316406,
        -1857.8677978515625,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -415.6344299316406,
        -1860.04052734375,
        905.0
      ],
      "bbox_max": [
        -413.4469299316406,
        -1857.8677978515625,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7771534323692322,
        -0.629311203956604,
        -0.0
      ],
      "plane_d": -1492.8223876953125,
      "bbox_min": [
        -415.6344299316406,
        -1860.04052734375,
        905.0
      ],
      "bbox_max": [
        -413.4469299316406,
        -1857.8677978515625,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7771633863449097,
        0.6292988657951355,
        -0.0
      ],
      "plane_d": 1491.2034912109375,
      "bbox_min": [
        -414.3908996582031,
        -1859.0335693359375,
        905.0
      ],
      "bbox_max": [
        -413.4469299316406,
        -1857.8677978515625,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -377.5999755859375,
      "bbox_min": [
        -410.993896484375,
        -1832.5933837890625,
        905.454345703125
      ],
      "bbox_max": [
        -362.4242858886719,
        -1769.9007568359375,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.897434908139985e-06,
        -0.9383435845375061,
        -0.345704048871994
      ],
      "plane_d": -1346.95751953125,
      "bbox_min": [
        -377.5999755859375,
        -1832.5933837890625,
        914.5042114257812
      ],
      "bbox_max": [
        -362.4242858886719,
        -1769.9007568359375,
        939.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -933.0,
      "bbox_min": [
        -377.5999755859375,
        -1779.199951171875,
        933.0
      ],
      "bbox_max": [
        -362.5135498046875,
        -1769.9007568359375,
        933.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5300138592720032,
        1.3651326298713684e-05,
        0.8479889631271362
      ],
      "plane_d": -598.6795654296875,
      "bbox_min": [
        -373.4189453125,
        -1832.5933837890625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1822.5078125,
        939.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5300142765045166,
        -7.227063179016113e-07,
        -0.8479887247085571
      ],
      "plane_d": 597.75927734375,
      "bbox_min": [
        -373.4189453125,
        -1832.5933837890625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1822.5078125,
        939.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 876.25927734375,
      "bbox_min": [
        -373.4189453125,
        -1832.5933837890625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1822.5078125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390785679221153,
        0.9992004036903381,
        0.021187884733080864
      ],
      "plane_d": 1788.90771484375,
      "bbox_min": [
        -373.4189453125,
        -1832.5933837890625,
        933.01171875
      ],
      "bbox_max": [
        -364.43896484375,
        -1822.5078125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8472548723220825,
        -0.03998177498579025,
        0.5296796560287476
      ],
      "plane_d": -886.268798828125,
      "bbox_min": [
        -373.4189453125,
        -1832.5933837890625,
        938.106689453125
      ],
      "bbox_max": [
        -372.5899963378906,
        -1822.907958984375,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -364.60009765625,
        -1832.521728515625,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1832.5,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1832.4998779296875,
      "bbox_min": [
        -364.60009765625,
        -1832.5108642578125,
        932.0
      ],
      "bbox_max": [
        -363.3201904296875,
        -1832.5,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -364.60009765625,
        -1832.5108642578125,
        932.0
      ],
      "bbox_max": [
        -364.5,
        -1832.5,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21578966081142426,
        0.22774909436702728,
        -0.9495078325271606
      ],
      "plane_d": 1190.307373046875,
      "bbox_min": [
        -410.993896484375,
        -1832.1759033203125,
        905.454345703125
      ],
      "bbox_max": [
        -383.56573486328125,
        -1815.2802734375,
        911.1553344726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21560680866241455,
        -0.22821097075939178,
        0.9494384527206421
      ],
      "plane_d": -1191.6541748046875,
      "bbox_min": [
        -410.82489013671875,
        -1832.1759033203125,
        905.454345703125
      ],
      "bbox_max": [
        -383.56573486328125,
        -1815.2802734375,
        911.1553344726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6631507277488708,
        0.7469943761825562,
        0.04722771793603897
      ],
      "plane_d": 1578.89697265625,
      "bbox_min": [
        -395.8169250488281,
        -1821.1407470703125,
        906.8723754882812
      ],
      "bbox_max": [
        -394.0953063964844,
        -1819.626953125,
        907.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03173423558473587,
        -0.11574684828519821,
        0.9927716255187988
      ],
      "plane_d": -1099.09912109375,
      "bbox_min": [
        -403.6466979980469,
        -1832.1571044921875,
        905.454345703125
      ],
      "bbox_max": [
        -383.56573486328125,
        -1819.713134765625,
        907.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6631507277488708,
        0.7469943761825562,
        0.04722771793603897
      ],
      "plane_d": 1578.89697265625,
      "bbox_min": [
        -395.754638671875,
        -1832.146484375,
        905.454345703125
      ],
      "bbox_max": [
        -384.386474609375,
        -1819.713134765625,
        907.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10662446916103363,
        0.05510290339589119,
        0.9927712678909302
      ],
      "plane_d": -840.0062866210938,
      "bbox_min": [
        -389.7801818847656,
        -1832.1571044921875,
        905.8372802734375
      ],
      "bbox_max": [
        -383.56573486328125,
        -1828.704833984375,
        906.6171264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8685542941093445,
        0.49334651231765747,
        0.04714541137218475
      ],
      "plane_d": 1194.313232421875,
      "bbox_min": [
        -386.1943054199219,
        -1832.1571044921875,
        905.8372802734375
      ],
      "bbox_max": [
        -383.56573486328125,
        -1828.704833984375,
        906.6171264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1061839610338211,
        -0.05535433813929558,
        -0.9928045868873596
      ],
      "plane_d": 838.9097900390625,
      "bbox_min": [
        -386.1943054199219,
        -1832.1502685546875,
        905.8372802734375
      ],
      "bbox_max": [
        -383.56573486328125,
        -1830.689208984375,
        906.1185913085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 361.5999450683594,
      "bbox_min": [
        -362.5135498046875,
        -1779.199951171875,
        926.3948364257812
      ],
      "bbox_max": [
        -361.5999755859375,
        -1775.8438720703125,
        933.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.579657914087875e-06,
        -0.9383420348167419,
        -0.34570831060409546
      ],
      "plane_d": -1346.9508056640625,
      "bbox_min": [
        -362.5135498046875,
        -1779.199951171875,
        926.3948364257812
      ],
      "bbox_max": [
        -361.5999755859375,
        -1775.8438720703125,
        933.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -933.0,
      "bbox_min": [
        -362.5135498046875,
        -1779.199951171875,
        933.0
      ],
      "bbox_max": [
        -361.5999755859375,
        -1775.8438720703125,
        933.0
      ],
      "face_count": 2
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}